'use strict';

angular.module('jsSdk', ['ngResource', 'ngCookies']).run(['jsSdk.auth', 'jsSdk.user', 'jsSdk.managementUser', 'jsSdk.config', 'jsSdk.AUTH_TYPES', function (auth, user, managementUser, sdkConfig, AUTH_TYPES) {
  if (auth.isLoggedIn() && sdkConfig.getUserOnStartUp) {
    if (sdkConfig.authType === AUTH_TYPES.CONSUMER) {
      user.me();
    } else {
      managementUser.me();
    }
  }
}]);

angular.module('jsSdk').config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('jsSdk.httpInterceptor');
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('jsSdk').provider('jsSdk.cacheConfig', [function () {
  var CacheConfig = function () {
    function CacheConfig() {
      _classCallCheck(this, CacheConfig);

      this._cacheConfigurations = {};
    }

    _createClass(CacheConfig, [{
      key: 'cacheResourceEndpoints',
      value: function cacheResourceEndpoints(resourceName, resourceEndpoints) {
        if (!resourceName) throw new Error('jsSdk.cacheConfig - cacheResourceEndpoints() - resourceName is required');
        if (!resourceEndpoints) throw new Error('jsSdk.cacheConfig - cacheResourceEndpoints() - resourceEndpoints is required');
        if (!angular.isArray(resourceEndpoints)) throw new Error('jsSdk.cacheConfig - cacheResourceEndpoints() - resourceEndpoints must be an array');

        var cacheEndpoints = this._cacheConfigurations[resourceName] || [];

        resourceEndpoints.forEach(function (endpoint) {
          if (!(endpoint in cacheEndpoints)) cacheEndpoints.push(endpoint);
        });

        this._cacheConfigurations[resourceName] = cacheEndpoints;

        return this;
      }
    }, {
      key: '$get',
      value: function $get() {
        return this;
      }
    }, {
      key: 'cacheConfigurations',
      get: function get() {
        return this._cacheConfigurations;
      }
    }]);

    return CacheConfig;
  }();

  return new CacheConfig();
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('jsSdk').provider('jsSdk.config', ['jsSdk.AUTH_TYPES', function (authTypes) {
  var CONSUMER_AUTH_KEY = 'auth_token';
  var MANAGEMENT_AUTH_KEY = 'management_auth_token';
  var PROSPECT_KEY = 'prospect_token';

  var Config = function () {
    function Config() {
      _classCallCheck(this, Config);

      this._apiBaseUrl = 'https://api.tablelist.com';
      this._version = '2.37.0';
      this._enableDebugMode = false;
      this._enableSecureCookie = true;
      this._enableCookieDomain = true;
      this._cookiePrefix = null;
      this._client = 'web';
      this._getUserOnStartUp = true;
      this._authType = authTypes.CONSUMER;
    }

    _createClass(Config, [{
      key: 'setClient',
      value: function setClient(client) {
        if (!client) throw new Error('jsSdk.config - setClient() - client is required');

        this._client = client;

        return this;
      }
    }, {
      key: 'setApiKey',
      value: function setApiKey(apiKey) {
        if (!apiKey) throw new Error('jsSdk.config - setApiKey() - apiKey is required');

        this._apiKey = apiKey;

        return this;
      }
    }, {
      key: 'setSubClient',
      value: function setSubClient(subClient) {
        if (!subClient) throw new Error('jsSdk.config - setSubClient() - subClient is required');

        this._subClient = subClient;

        return this;
      }
    }, {
      key: 'setApiBaseUrl',
      value: function setApiBaseUrl(baseUrl) {
        if (!baseUrl) throw new Error('jsSdk.config - setApiBaseUrl() - baseUrl is required');

        this._apiBaseUrl = baseUrl;

        return this;
      }
    }, {
      key: 'setEnableDebugMode',
      value: function setEnableDebugMode(enable) {
        if (enable !== true && enable !== false) throw new Error('jsSdk.config - enableDebugMode() - enable must be a boolean');
        this._enableDebugMode = enable;
        return this;
      }
    }, {
      key: 'setCookiePrefix',
      value: function setCookiePrefix(prefix) {
        if (!prefix) throw new Error('jsSdk.config - setCookiePrefix() - prefix is required');
        this._cookiePrefix = prefix;
        return this;
      }
    }, {
      key: 'setEnableSecureCookie',
      value: function setEnableSecureCookie(enable) {
        if (enable !== true && enable !== false) throw new Error('jsSdk.config - enableSecureCookie() - enable must be a boolean');
        this._enableSecureCookie = enable;
        return this;
      }
    }, {
      key: 'setEnableCookieDomain',
      value: function setEnableCookieDomain(enable) {
        if (enable !== true && enable !== false) throw new Error('jsSdk.config - enableCookieDomain() - enable must be a boolean');
        this._enableCookieDomain = enable;
        return this;
      }
    }, {
      key: 'setAffiliateId',
      value: function setAffiliateId(id) {
        if (!id) throw new Error('jsSdk.config - setAffiliateId() - id is required');
        this._affiliateId = id;
        return this;
      }
    }, {
      key: 'setAttributionId',
      value: function setAttributionId(id) {
        if (!id) throw new Error('jsSdk.config - setAttributionId() - id is required');
        this._attributionId = id;
        return this;
      }
    }, {
      key: 'setAttributionType',
      value: function setAttributionType(type) {
        if (!type) throw new Error('jsSdk.config - setAttributionType() - type is required');
        this._attributionType = type;
        return this;
      }
    }, {
      key: 'setGetUserOnStartUp',
      value: function setGetUserOnStartUp(set) {
        this._getUserOnStartUp = set === false ? false : true;

        return this;
      }
    }, {
      key: 'setAuthType',
      value: function setAuthType(authType) {
        if (!authType) throw new Error('jsSdk.config - setAuthType() - authType is required');

        this._authType = authType;

        return this;
      }
    }, {
      key: '$get',
      value: function $get() {
        return this;
      }
    }, {
      key: 'version',
      get: function get() {
        return this._version;
      }
    }, {
      key: 'affiliateId',
      get: function get() {
        return this._affiliateId;
      }
    }, {
      key: 'attributionId',
      get: function get() {
        return this._attributionId;
      }
    }, {
      key: 'attributionType',
      get: function get() {
        return this._attributionType;
      }
    }, {
      key: 'client',
      get: function get() {
        return this._client;
      }
    }, {
      key: 'apiKey',
      get: function get() {
        return this._apiKey;
      }
    }, {
      key: 'subClient',
      get: function get() {
        return this._subClient;
      }
    }, {
      key: 'apiBaseUrl',
      get: function get() {
        return this._apiBaseUrl;
      }
    }, {
      key: 'enableDebugMode',
      get: function get() {
        return this._enableDebugMode;
      }
    }, {
      key: 'enableSecureCookie',
      get: function get() {
        return this._enableSecureCookie;
      }
    }, {
      key: 'cookiePrefix',
      get: function get() {
        return this._cookiePrefix;
      }
    }, {
      key: 'enableCookieDomain',
      get: function get() {
        return this._enableCookieDomain;
      }
    }, {
      key: 'consumerAuthTokenKey',
      get: function get() {
        return CONSUMER_AUTH_KEY;
      }
    }, {
      key: 'managementAuthTokenKey',
      get: function get() {
        return MANAGEMENT_AUTH_KEY;
      }
    }, {
      key: 'prospectTokenKey',
      get: function get() {
        return PROSPECT_KEY;
      }
    }, {
      key: 'getUserOnStartUp',
      get: function get() {
        return this._getUserOnStartUp;
      }
    }, {
      key: 'authType',
      get: function get() {
        return this._authType;
      }
    }]);

    return Config;
  }();

  return new Config();
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.admissionGroup', ['jsSdk.commonService', 'jsSdk.admissionGroup.resource', function (CommonService, admissionGroup) {
  var AdmissionGroupService = function (_CommonService) {
    _inherits(AdmissionGroupService, _CommonService);

    function AdmissionGroupService() {
      _classCallCheck(this, AdmissionGroupService);

      return _possibleConstructorReturn(this, (AdmissionGroupService.__proto__ || Object.getPrototypeOf(AdmissionGroupService)).call(this, admissionGroup, 'AdmissionGroupService'));
    }

    _createClass(AdmissionGroupService, [{
      key: 'listByCustomerId',
      value: function listByCustomerId(customerId, options) {
        if (!customerId) throw new Error('jsSdk.admissionGroup - listByCustomerId() - customerId is required');
        options = options || {};

        options.customerId = customerId;

        return this._resource.listByCustomerId(options).$promise;
      }
    }, {
      key: 'createBulk',
      value: function createBulk(options) {
        if (!options) throw new Error('jsSdk.admissionGroup - createBulk() - options is required');

        return this._resource.createBulk({}, options).$promise;
      }
    }, {
      key: 'performActionById',
      value: function performActionById(id, options) {
        if (!id) throw new Error('jsSdk.admissionGroup - performActionById() - id is required');

        return this._resource.performActionById({
          id: id
        }, options).$promise;
      }
    }, {
      key: 'performAction',
      value: function performAction(options) {
        if (!options) throw new Error('jsSdk.admissionGroup - performAction() - options is required');

        return this._resource.performAction({}, options).$promise;
      }
    }]);

    return AdmissionGroupService;
  }(CommonService);

  return new AdmissionGroupService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.admissionGroup.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/admission-group/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var AdmissionGroup = resourceFactory('jsSdk.admissionGroup.resource', ENDPOINT, PARAM_DEFAULTS, {
    performActionById: {
      method: 'POST',
      url: ENDPOINT + '/action',
      isArray: false
    },
    createBulk: {
      method: 'POST',
      url: '/admission-group-bulk',
      isArray: true
    },
    performAction: {
      method: 'POST',
      url: '/admission-group/action',
      isArray: false
    },
    listByCustomerId: {
      method: 'GET',
      url: 'customer/:customerId/admission-group',
      isArray: true,
      params: {
        customerId: '@customerId'
      }
    }
  });

  return AdmissionGroup;
}]);
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.admissionGroupRequest', ['jsSdk.commonService', 'jsSdk.admissionGroupRequest.resource', function (CommonService, admissionGroupRequest) {
  var AdmissionGroupRequestService = function (_CommonService) {
    _inherits(AdmissionGroupRequestService, _CommonService);

    function AdmissionGroupRequestService() {
      _classCallCheck(this, AdmissionGroupRequestService);

      return _possibleConstructorReturn(this, (AdmissionGroupRequestService.__proto__ || Object.getPrototypeOf(AdmissionGroupRequestService)).call(this, admissionGroupRequest, 'AdmissionGroupRequestService'));
    }

    return AdmissionGroupRequestService;
  }(CommonService);

  return new AdmissionGroupRequestService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.admissionGroupRequest.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/admission-group-request/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var AdmissionGroup = resourceFactory('jsSdk.admissionGroupRequest.resource', ENDPOINT, PARAM_DEFAULTS, {});

  return AdmissionGroup;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.attributionSourceReport', ['jsSdk.commonService', 'jsSdk.attributionSourceReport.resource', function (CommonService, attributionSourceReport) {
  var AttributionSourceReportService = function (_CommonService) {
    _inherits(AttributionSourceReportService, _CommonService);

    function AttributionSourceReportService() {
      _classCallCheck(this, AttributionSourceReportService);

      return _possibleConstructorReturn(this, (AttributionSourceReportService.__proto__ || Object.getPrototypeOf(AttributionSourceReportService)).call(this, attributionSourceReport, 'AttributionSourceReportService'));
    }

    _createClass(AttributionSourceReportService, [{
      key: 'list',
      value: function list() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


        return this._resource.list(options).$promise;
      }
    }]);

    return AttributionSourceReportService;
  }(CommonService);

  return new AttributionSourceReportService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.attributionSourceReport.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/attribution-source-report/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var AttributionSourceReport = resourceFactory('jsSdk.attributionSourceReport.resource', ENDPOINT, PARAM_DEFAULTS, {
    list: {
      method: 'GET',
      url: ENDPOINT,
      isArray: true
    }
  });

  return AttributionSourceReport;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.attributionSource', ['jsSdk.commonService', 'jsSdk.attributionSource.resource', function (CommonService, attributionSource) {
  var AttributionSourceService = function (_CommonService) {
    _inherits(AttributionSourceService, _CommonService);

    function AttributionSourceService() {
      _classCallCheck(this, AttributionSourceService);

      return _possibleConstructorReturn(this, (AttributionSourceService.__proto__ || Object.getPrototypeOf(AttributionSourceService)).call(this, attributionSource, 'AttributionSourceService'));
    }

    _createClass(AttributionSourceService, [{
      key: 'createByOrganizationId',
      value: function createByOrganizationId(organizationId, data) {
        if (!organizationId) throw new Error('organizationId is required');
        if (!data) throw new Error('organizationId is required');
        if (!data.name) throw new Error('data.name is required');

        return this.create({
          organizationId: organizationId,
          name: data.name
        });
      }
    }, {
      key: 'performActionByOrganizationId',
      value: function performActionByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('organizationId is required');
        if (!options) throw new Error('options is required');

        return this._resource.performActionByOrganizationId({
          organizationId: organizationId
        }, options).$promise;
      }
    }, {
      key: 'listByOrganizationId',
      value: function listByOrganizationId(organizationId) {
        if (!organizationId) throw new Error('organizationId is required');

        return this._resource.listByOrganizationId({
          organizationId: organizationId
        }).$promise;
      }
    }, {
      key: 'listByManagementUserId',
      value: function listByManagementUserId(managementUserId) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!managementUserId) throw new Error('managementUserId is required');

        options.managementUserId = managementUserId;

        return this._resource.listByManagementUserId(options).$promise;
      }
    }, {
      key: 'updateByIdAndOrganizationId',
      value: function updateByIdAndOrganizationId(id, organizationId, options) {
        if (!id) throw new Error('jsSdk.attributionSource - updateByIdAndOrganizationId() - id is required');
        if (!organizationId) throw new Error('jsSdk.attributionSource - updateByIdAndOrganizationId() - organizationId is required');
        if (!options) throw new Error('jsSdk.attributionSource - updateByIdAndOrganizationId() - options is required');

        return this._resource.updateByIdAndOrganizationId({
          id: id,
          organizationId: organizationId
        }, options).$promise;
      }
    }, {
      key: 'deleteByIdAndOrganizationId',
      value: function deleteByIdAndOrganizationId(id, organizationId) {
        if (!id) throw new Error('jsSdk.attributionSource - deleteByIdAndOrganizationId() - id is required');
        if (!organizationId) throw new Error('jsSdk.attributionSource - deleteByIdAndOrganizationId() - organizationId is required');

        return this._resource.deleteByIdAndOrganizationId({
          id: id,
          organizationId: organizationId
        }).$promise;
      }
    }]);

    return AttributionSourceService;
  }(CommonService);

  return new AttributionSourceService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.attributionSource.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/organization/:organizationId/attribution-source/:id';
  var PARAM_DEFAULTS = {
    id: '@id',
    organizationId: '@organizationId'
  };

  var AttributionSource = resourceFactory('jsSdk.attributionSource.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByOrganizationId: {
      method: 'GET',
      url: '/organization/:organizationId/attribution-source',
      isArray: true
    },
    listByManagementUserId: {
      method: 'GET',
      url: '/management-user/:managementUserId/attribution-source',
      isArray: true
    },
    updateByIdAndOrganizationId: {
      method: 'PUT',
      url: 'organization/:organizationId/attribution-source/:id',
      isArray: false
    },
    deleteByIdAndOrganizationId: {
      method: 'DELETE',
      url: 'organization/:organizationId/attribution-source/:id',
      isArray: false
    },
    performActionByOrganizationId: {
      method: 'POST',
      url: 'organization/:organizationId/attribution-source/action',
      isArray: false
    }
  });

  return AttributionSource;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.auth', ['jsSdk.config', 'jsSdk.commonService', 'jsSdk.auth.resource', 'jsSdk.keychain', 'jsSdk.user', 'jsSdk.managementUser', 'jsSdk.cache', '$q', 'jsSdk.AUTH_TYPES', function (config, CommonService, auth, keychain, user, managementUser, cache, $q, AUTH_TYPES) {

  var EVENTS = {
    CONSUMER_LOGGED_IN: 'CONSUMER_LOGGED_IN',
    CONSUMER_LOGGED_OUT: 'CONSUMER_LOGGED_OUT',
    MANAGEMENT_LOGGED_IN: 'MANAGEMENT_LOGGED_IN',
    MANAGEMENT_LOGGED_OUT: 'MANAGEMENT_LOGGED_OUT'
  };

  var AuthService = function (_CommonService) {
    _inherits(AuthService, _CommonService);

    function AuthService() {
      _classCallCheck(this, AuthService);

      return _possibleConstructorReturn(this, (AuthService.__proto__ || Object.getPrototypeOf(AuthService)).call(this, auth, 'AuthService'));
    }

    _createClass(AuthService, [{
      key: 'login',
      value: function login(options) {
        var _this2 = this;

        if (!options) throw new Error('jsSdk.auth - login() - options is required');
        if (!options.email) throw new Error('jsSdk.auth - login() - options.email is required');
        if (!options.password) throw new Error('jsSdk.auth - login() - options.password is required');

        options.type = options.type || this.defaultAuthType;

        if (options.type === AUTH_TYPES.MANAGEMENT) {
          keychain.removeManagementAuthToken();

          managementUser.removeCurrentUser();
        }

        if (options.type === AUTH_TYPES.CONSUMER) {
          keychain.removeConsumerAuthToken();

          user.removeCurrentUser();
        }

        var deferred = $q.defer();

        auth.login({}, options).$promise.then(function (auth) {
          var currentUser = void 0;

          if (options.type === AUTH_TYPES.MANAGEMENT) {
            keychain.setManagementAuthToken(auth.token);

            managementUser.setCurrentUser(auth.managementUser);

            currentUser = managementUser.getCurrentUser();

            _this2.emit(_this2.EVENTS.MANAGEMENT_LOGGED_IN, currentUser);
          }

          if (options.type === AUTH_TYPES.CONSUMER) {
            keychain.setConsumerAuthToken(auth.token);

            user.setCurrentUser(auth.user);

            currentUser = user.getCurrentUser();

            _this2.emit(_this2.EVENTS.CONSUMER_LOGGED_IN, currentUser);
          }

          return deferred.resolve(auth);
        }).catch(deferred.reject);

        return deferred.promise;
      }
    }, {
      key: 'register',
      value: function register(options) {
        var _this3 = this;

        if (!options) throw new Error('jsSdk.auth - register() - options is required');
        if (!options.email) throw new Error('jsSdk.auth - register() - options.email is required');
        if (!options.password) throw new Error('jsSdk.auth - register() - options.password is required');

        options.type = options.type || this.defaultAuthType;

        var deferred = $q.defer();

        auth.register({}, options).$promise.then(function (auth) {
          var currentUser = void 0;

          if (options.type === AUTH_TYPES.MANAGEMENT) {
            keychain.setManagementAuthToken(auth.token);

            managementUser.setCurrentUser(auth.managementUser);

            currentUser = managementUser.getCurrentUser();

            _this3.emit(_this3.EVENTS.MANAGEMENT_LOGGED_IN, currentUser);
          }

          if (options.type === AUTH_TYPES.CONSUMER) {
            keychain.setConsumerAuthToken(auth.token);

            user.setCurrentUser(auth.user);

            currentUser = user.getCurrentUser();

            _this3.emit(_this3.EVENTS.CONSUMER_LOGGED_IN, currentUser);
          }

          return deferred.resolve(auth);
        }).catch(deferred.reject);

        return deferred.promise;
      }
    }, {
      key: 'forgotPassword',
      value: function forgotPassword(options) {
        if (!options) throw new Error('jsSdk.auth - forgotPassword() - options is required');
        if (!options.email) throw new Error('jsSdk.auth - forgotPassword() - options.email is required');

        options.type = options.type || this.defaultAuthType;

        return auth.forgotPassword({}, options).$promise;
      }
    }, {
      key: 'changePassword',
      value: function changePassword(options) {
        if (!options) throw new Error('jsSdk.auth - changePassword() - options is required');
        if (!options.password) throw new Error('jsSdk.auth - changePassword() - options.password is required');
        if (!options.resetToken) throw new Error('jsSdk.auth - changePassword() - options.resetToken is required');

        options.type = options.type || this.defaultAuthType;

        return auth.changePassword({}, options).$promise;
      }
    }, {
      key: 'logout',
      value: function logout(options) {
        options = options || {};
        options.type = options.type || this.defaultAuthType;

        if (options.type === AUTH_TYPES.MANAGEMENT) {
          keychain.removeManagementAuthToken();

          managementUser.removeCurrentUser();

          this.emit(this.EVENTS.MANAGEMENT_LOGGED_OUT);
        }

        if (options.type === AUTH_TYPES.CONSUMER) {
          keychain.removeConsumerAuthToken();

          user.removeCurrentUser();

          this.emit(this.EVENTS.CONSUMER_LOGGED_OUT);
        }

        cache.removeAll();

        return true;
      }
    }, {
      key: 'isLoggedIn',
      value: function isLoggedIn(options) {
        options = options || {};
        options.type = options.type || this.defaultAuthType;

        var authToken = void 0;

        if (options.type === AUTH_TYPES.MANAGEMENT) {
          authToken = keychain.getManagementAuthToken();
        }

        if (options.type === AUTH_TYPES.CONSUMER) {
          authToken = keychain.getConsumerAuthToken();
        }

        return authToken ? true : false;
      }
    }, {
      key: 'setPasswordByManagementUserId',
      value: function setPasswordByManagementUserId(managementUserId, password) {
        if (!managementUserId) throw new Error('jsSdk.auth - setPasswordByManagementUserId() - managementUserId is required');
        if (!password) throw new Error('jsSdk.auth - setPasswordByManagementUserId() - password is required');

        var options = {
          managementUserId: managementUserId,
          password: password,
          type: AUTH_TYPES.MANAGEMENT
        };

        return this._resource.setPassword(options).$promise;
      }
    }, {
      key: 'EVENTS',
      get: function get() {
        return EVENTS;
      }
    }, {
      key: 'defaultAuthType',
      get: function get() {
        return config.authType;
      }
    }]);

    return AuthService;
  }(CommonService);

  return new AuthService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.auth.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/auth';
  var PARAM_DEFAULTS = {};

  var Auth = resourceFactory('jsSdk.auth.resource', ENDPOINT, PARAM_DEFAULTS, {
    login: {
      method: 'POST',
      url: ENDPOINT + '/login',
      isArray: false
    },
    register: {
      method: 'POST',
      url: ENDPOINT + '/register',
      isArray: false
    },
    forgotPassword: {
      method: 'POST',
      url: ENDPOINT + '/forgot',
      isArray: false
    },
    changePassword: {
      method: 'POST',
      url: ENDPOINT + '/reset',
      isArray: false
    },
    setPassword: {
      method: 'POST',
      url: ENDPOINT + '/password',
      isArray: false
    }
  });

  return Auth;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.availableLayoutTable', ['jsSdk.commonService', 'jsSdk.availableLayoutTable.resource', function (CommonService, availableLayoutTable) {
  var AvailableLayoutTableService = function (_CommonService) {
    _inherits(AvailableLayoutTableService, _CommonService);

    function AvailableLayoutTableService() {
      _classCallCheck(this, AvailableLayoutTableService);

      return _possibleConstructorReturn(this, (AvailableLayoutTableService.__proto__ || Object.getPrototypeOf(AvailableLayoutTableService)).call(this, availableLayoutTable, 'AvailableLayoutTableService'));
    }

    _createClass(AvailableLayoutTableService, [{
      key: 'listByVenueId',
      value: function listByVenueId(venueId, options) {
        if (!venueId) throw new Error('jsSdk.availableLayoutTable - listByVenueId() - venueId is required');
        options = options || {};

        options.venueId = venueId;

        return this._resource.listByVenueId(options).$promise;
      }
    }]);

    return AvailableLayoutTableService;
  }(CommonService);

  return new AvailableLayoutTableService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.availableLayoutTable.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/available-layout-table/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var LayoutTable = resourceFactory('jsSdk.availableLayoutTable.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByVenueId: {
      method: 'GET',
      url: 'venue/:venueId/available-layout-table',
      isArray: true
    }
  });

  return LayoutTable;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.booking', ['jsSdk.commonService', 'jsSdk.booking.resource', function (CommonService, booking) {

  var ACTION_TYPE = {
    UPDATE_PAYMENT_METHOD: 'UPDATE_PAYMENT_PLAN_PAYMENT_METHOD',
    CHARGE_PAST_DUE: 'CHARGE_PAST_DUE_PAYMENT_PLAN'
  };

  var BookingService = function (_CommonService) {
    _inherits(BookingService, _CommonService);

    function BookingService() {
      _classCallCheck(this, BookingService);

      return _possibleConstructorReturn(this, (BookingService.__proto__ || Object.getPrototypeOf(BookingService)).call(this, booking, 'BookingService'));
    }

    _createClass(BookingService, [{
      key: 'accept',
      value: function accept(bookingId, options) {
        if (!bookingId) throw new Error('jsSdk.booking - accept() - bookingId is required');
        if (!options) throw new Error('jsSdk.booking - accept() - options is required');
        if (!options.userId) throw new Error('jsSdk.booking - accept() - options.userId is required');
        if (!options.paymentProfileId) throw new Error('jsSdk.booking - accept() - options.paymentProfileId is required');
        options.id = bookingId;
        return this._resource.accept(options).$promise;
      }
    }, {
      key: 'addCondition',
      value: function addCondition(bookingId, options) {
        if (!bookingId) throw new Error('jsSdk.booking - addCondition() - bookingId is required');
        if (!options) throw new Error('jsSdk.booking - addCondition() - options is required');
        if (!options.condition) throw new Error('jsSdk.booking - addCondition() - options.condition is required');
        options.id = bookingId;
        return this._resource.addCondition(options).$promise;
      }
    }, {
      key: 'authorize',
      value: function authorize(bookingId, options) {
        if (!bookingId) throw new Error('jsSdk.booking - authorize() - bookingId is required');
        if (!options) throw new Error('jsSdk.booking - authorize() - options is required');
        if (!options.userId) throw new Error('jsSdk.booking - authorize() - options.userId is required');
        if (!options.paymentProfileId) throw new Error('jsSdk.booking - authorize() - options.paymentProfileId is required');
        options.id = bookingId;
        return this._resource.authorize(options).$promise;
      }
    }, {
      key: 'complete',
      value: function complete(bookingId, options) {
        if (!bookingId) throw new Error('jsSdk.booking - complete() - bookingId is required');
        options = options || {};
        options.id = bookingId;
        return this._resource.complete(options).$promise;
      }
    }, {
      key: 'decline',
      value: function decline(bookingId, options) {
        if (!bookingId) throw new Error('jsSdk.booking - decline() - bookingId is required');
        if (!options) throw new Error('jsSdk.booking - decline() - options is required');
        if (!options.userId) throw new Error('jsSdk.booking - decline() - options.userId is required');
        options.id = bookingId;
        return this._resource.decline(options).$promise;
      }
    }, {
      key: 'join',
      value: function join(splitCode, options) {
        if (!splitCode) throw new Error('jsSdk.booking - join() - splitCode is required');
        options = options || {};
        options.splitCode = splitCode;
        return this._resource.join(options).$promise;
      }
    }, {
      key: 'readBySplitCode',
      value: function readBySplitCode(splitCode, options) {
        if (!splitCode) throw new Error('jsSdk.booking - readBySplitCode() - splitCode is required');
        options = options || {};
        options.splitCode = splitCode;
        return this._resource.readBySplitCode(options).$promise;
      }
    }, {
      key: 'read',
      value: function read(bookingId, options) {
        if (!bookingId) throw new Error('jsSdk.booking - read() - bookingId is required');
        options = options || {};

        options.id = bookingId;
        return this._resource.read(options).$promise;
      }
    }, {
      key: 'removeBookingDiscount',
      value: function removeBookingDiscount(bookingId, options) {
        if (!bookingId) throw new Error('jsSdk.booking - removeBookingDiscount() - bookingId is required');
        if (!options) throw new Error('jsSdk.booking - removeBookingDiscount() - options is required');
        if (!options.bookingDiscountId) throw new Error('jsSdk.booking - removeBookingDiscount() - options.bookingDiscountId is required');

        options.id = bookingId;
        return this._resource.removeBookingDiscount(options).$promise;
      }
    }, {
      key: 'addBookingDiscount',
      value: function addBookingDiscount(bookingId, options) {
        if (!bookingId) throw new Error('jsSdk.booking - addBookingDiscount() - bookingId is required');
        if (!options) throw new Error('jsSdk.booking - addBookingDiscount() - options is required');
        if (!options.userDiscountId && !options.promoCode) throw new Error('jsSdk.booking - addBookingDiscount() - options.userDiscountId or options.promoCode is required');
        if (options.userDiscountId && options.promoCode) throw new Error('jsSdk.booking - addBookingDiscount() - options.userDiscountId and options.promoCode were both provided. ' + 'Please only provide a single discount source.');
        options.id = bookingId;
        return this._resource.addBookingDiscount(options).$promise;
      }
    }, {
      key: 'listByUserId',
      value: function listByUserId(userId, options) {
        if (!userId) throw new Error('jsSdk.booking - listByUserId() - userId is required');
        options = options || {};
        options.userId = userId;
        return this._resource.listByUserId(options).$promise;
      }
    }, {
      key: 'listByVenueId',
      value: function listByVenueId(venueId, options) {
        if (!venueId) throw new Error('jsSdk.booking - listByVenueId() - venueId is required');
        options = options || {};
        options.venueId = venueId;
        return this._resource.listByVenueId(options).$promise;
      }
    }, {
      key: 'listByAdmissionGroupId',
      value: function listByAdmissionGroupId(admissionGroupId, options) {
        if (!admissionGroupId) throw new Error('jsSdk.booking - listByAdmissionGroupId() - admissionGroupId is required');
        options = options || {};
        options.admissionGroupId = admissionGroupId;
        return this._resource.listByAdmissionGroupId(options).$promise;
      }
    }, {
      key: 'performAction',
      value: function performAction(id, action, options) {
        if (!id) throw new Error('jsSdk.booking - performAction() - id is required');
        if (!action) throw new Error('jsSdk.booking - performAction() - action is required');
        options = options || {};
        options.id = id;
        options.type = action;
        return this._resource.action(options).$promise;
      }
    }, {
      key: 'updatePaymentMethod',
      value: function updatePaymentMethod(id, options) {
        if (!id) throw new Error('jsSdk.booking - updatePaymentMethod() - id is required');
        if (!options) throw new Error('jsSdk.booking - updatePaymentMethod() - options is required');
        if (!options.paymentProfileId) throw new Error('jsSdk.booking - updatePaymentMethod() - options.paymentProfileId is required');
        return this.performAction(id, ACTION_TYPE.UPDATE_PAYMENT_METHOD, options);
      }
    }, {
      key: 'chargePastDue',
      value: function chargePastDue(id, options) {
        if (!id) throw new Error('jsSdk.booking - chargePastDue() - id is required');
        return this.performAction(id, ACTION_TYPE.CHARGE_PAST_DUE, options);
      }
    }, {
      key: 'ACTION_TYPE',
      get: function get() {
        return ACTION_TYPE;
      }
    }]);

    return BookingService;
  }(CommonService);

  return new BookingService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.booking.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/booking/:id';

  var PARAM_DEFAULTS = {
    id: '@id',
    splitCode: '@splitCode'
  };

  var Booking = resourceFactory('jsSdk.booking.resource', ENDPOINT, PARAM_DEFAULTS, {
    accept: {
      method: 'POST',
      url: ENDPOINT + '/accept'
    },
    action: {
      method: 'POST',
      url: ENDPOINT + '/action'
    },
    addBookingDiscount: {
      method: 'POST',
      url: ENDPOINT + '/booking-discount'
    },
    addCondition: {
      method: 'POST',
      url: ENDPOINT + '/condition'
    },
    authorize: {
      method: 'POST',
      url: ENDPOINT + '/authorize'
    },
    complete: {
      method: 'POST',
      url: ENDPOINT + '/complete'
    },
    decline: {
      method: 'POST',
      url: ENDPOINT + '/decline'
    },
    join: {
      method: 'POST',
      url: 'booking/join'
    },
    read: {
      method: 'GET',
      url: ENDPOINT
    },
    readBySplitCode: {
      method: 'GET',
      url: 'booking/split/:splitCode'
    },
    removeBookingDiscount: {
      method: 'DELETE',
      url: ENDPOINT + '/booking-discount/:bookingDiscountId'
    },
    listByUserId: {
      method: 'GET',
      url: '/user/:userId/booking',
      isArray: true
    },
    listByVenueId: {
      method: 'GET',
      url: '/venue/:venueId/booking',
      isArray: true
    },
    listByAdmissionGroupId: {
      method: 'GET',
      url: '/admission-group/:admissionGroupId/booking',
      isArray: true
    }
  });

  return Booking;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.bookingTerms', ['jsSdk.commonService', 'jsSdk.bookingTerms.resource', function (CommonService, bookingTerms) {
  var BookingService = function (_CommonService) {
    _inherits(BookingService, _CommonService);

    function BookingService() {
      _classCallCheck(this, BookingService);

      return _possibleConstructorReturn(this, (BookingService.__proto__ || Object.getPrototypeOf(BookingService)).call(this, bookingTerms, 'BookingService'));
    }

    _createClass(BookingService, [{
      key: 'listByBookingId',
      value: function listByBookingId(bookingId, options) {
        if (!bookingId) throw new Error('jsSdk.bookingTerms - listByBookingId() - bookingId is required');
        options = options || {};
        options.id = bookingId;
        return this._resource.listByBookingId(options).$promise;
      }
    }]);

    return BookingService;
  }(CommonService);

  return new BookingService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.bookingTerms.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/booking/:id';

  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Booking = resourceFactory('jsSdk.bookingTerms.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByBookingId: {
      method: 'GET',
      url: ENDPOINT + '/terms',
      isArray: true
    }
  });

  return Booking;
}]);
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.city', ['jsSdk.commonService', 'jsSdk.city.resource', function (CommonService, city) {
  var CityService = function (_CommonService) {
    _inherits(CityService, _CommonService);

    function CityService() {
      _classCallCheck(this, CityService);

      return _possibleConstructorReturn(this, (CityService.__proto__ || Object.getPrototypeOf(CityService)).call(this, city, 'CityService'));
    }

    return CityService;
  }(CommonService);

  return new CityService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.city.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/city/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var City = resourceFactory('jsSdk.city.resource', ENDPOINT, PARAM_DEFAULTS, {});

  return City;
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.resourceFactory', ['$resource', 'jsSdk.http', 'jsSdk.cacheConfig', function ($resource, http, cacheConfig) {

  function resourceFactory(resourceName, endpoint, paramDefaults, actions) {
    if (!resourceName) throw new Error('jsSdk.resourceFactory - resourceName is required');
    if (!endpoint) throw new Error('jsSdk.resourceFactory - endpoint is required');

    paramDefaults = paramDefaults || {};
    actions = actions || {};

    var url = http.getApiUrl(endpoint);

    actions = _addCommonActions(endpoint, actions);

    actions = _convertActionEndpoints(actions);

    actions = _enableCachingOnEndpoints(resourceName, actions);

    var resource = $resource(url, paramDefaults, actions);

    delete resource.get;
    delete resource.save;
    delete resource.delete;
    delete resource.query;
    delete resource.remove;

    return resource;
  }

  function _enableCachingOnEndpoints(resourceName, actions) {
    if (!resourceName || !actions) return;

    var resourceCacheConfigurations = cacheConfig.cacheConfigurations[resourceName];

    if (!resourceCacheConfigurations || !resourceCacheConfigurations.length) return actions;

    for (var endpointName in actions) {
      var action = actions[endpointName];

      if (resourceCacheConfigurations.indexOf(endpointName) > -1) {
        if (action.method !== 'GET') {
          console.log('jsSdk.cache - trying to configure caching for a non GET request endpoint. Cacheing only works for GET requests. Skipping this configuration.');
        } else {
          action.cache = true;
        }
      }
    }

    return actions;
  }

  function _convertActionEndpoints(actions) {

    for (var key in actions) {
      var action = actions[key];

      if (action.url) {
        action.url = http.getApiUrl(action.url);
      }
    }

    return actions;
  }

  function _addCommonActions(endpoint, actions) {
    var defaultActions = {
      readById: {
        method: 'GET'
      },
      create: {
        method: 'POST'
      },
      list: {
        method: 'GET',
        isArray: true
      },
      updateById: {
        method: 'PUT'
      },
      patchById: {
        method: 'PATCH'
      },
      deleteById: {
        method: 'DELETE'
      }
    };

    return angular.extend(defaultActions, actions);
  }

  return resourceFactory;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.commonService', ['$rootScope', 'jsSdk.eventEmitter', function ($rootScope, EventEmitter) {

  var DEFAULT_LIMIT = 100;
  var DEFAULT_SORT = '-created';

  var CommonService = function (_EventEmitter) {
    _inherits(CommonService, _EventEmitter);

    function CommonService(resource, eventNamespace) {
      _classCallCheck(this, CommonService);

      if (!resource) throw new Error('jsSdk.commonService - constructor - resource is required');
      if (!eventNamespace) throw new Error('jsSdk.commonService - constructor - eventNamespace is required');

      var _this = _possibleConstructorReturn(this, (CommonService.__proto__ || Object.getPrototypeOf(CommonService)).call(this, eventNamespace));

      _this._resource = resource;
      return _this;
    }

    _createClass(CommonService, [{
      key: 'list',
      value: function list(options) {
        options = options || {};

        options.limit = options.limit || this.DEFAULT_LIMIT;
        options.sort = options.sort || this.DEFAULT_SORT;
        options.query = options.query ? JSON.stringify(options.query) : options.query;

        if (options.fields && Array.isArray(options.fields)) {
          options.fields = options.fields.join(',');
        }

        return this._resource.list(options).$promise;
      }
    }, {
      key: 'readById',
      value: function readById(id, options) {
        if (!id) throw new Error('jsSdk.commonService - readById() - id is required');
        options = options || {};

        options.id = id;

        if (options.fields && Array.isArray(options.fields)) {
          options.fields = options.fields.join(',');
        }

        return this._resource.readById(options).$promise;
      }
    }, {
      key: 'create',
      value: function create(options) {
        if (!options) throw new Error('jsSdk.commonService - create() - options is required');

        return this._resource.create({}, options).$promise;
      }
    }, {
      key: 'updateById',
      value: function updateById(id, options) {
        if (!id) throw new Error('jsSdk.commonService - updateById() - id is required');
        if (!options) throw new Error('jsSdk.commonService - updateById() - options is required');

        return this._resource.updateById({
          id: id
        }, options).$promise;
      }
    }, {
      key: 'patchById',
      value: function patchById(id, options) {
        if (!id) throw new Error('jsSdk.commonService - patchById() - id is required');
        if (!options) throw new Error('jsSdk.commonService - patchById() - options is required');

        return this._resource.patchById({
          id: id
        }, options).$promise;
      }
    }, {
      key: 'deleteById',
      value: function deleteById(id, options) {
        if (!id) throw new Error('jsSdk.commonService - deleteById() - id is required');

        return this._resource.deleteById({
          id: id
        }, options).$promise;
      }
    }, {
      key: 'DEFAULT_LIMIT',
      get: function get() {
        return DEFAULT_LIMIT;
      }
    }, {
      key: 'DEFAULT_SORT',
      get: function get() {
        return DEFAULT_SORT;
      }
    }]);

    return CommonService;
  }(EventEmitter);

  return CommonService;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.confirmationRequest', ['jsSdk.commonService', 'jsSdk.confirmationRequest.resource', function (CommonService, confirmationRequest) {
  var ConfirmationRequestService = function (_CommonService) {
    _inherits(ConfirmationRequestService, _CommonService);

    function ConfirmationRequestService() {
      _classCallCheck(this, ConfirmationRequestService);

      return _possibleConstructorReturn(this, (ConfirmationRequestService.__proto__ || Object.getPrototypeOf(ConfirmationRequestService)).call(this, confirmationRequest, 'ConfirmationRequestService'));
    }

    _createClass(ConfirmationRequestService, [{
      key: 'createByAdmissionGroupId',
      value: function createByAdmissionGroupId(admissionGroupId, options) {
        if (!admissionGroupId) throw new Error('jsSdk.confirmationRequest - createByAdmissionGroupId() - admissionGroupId is required');
        if (!options) throw new Error('jsSdk.confirmationRequest - createByAdmissionGroupId() - options is required');

        return this._resource.createByAdmissionGroupId({
          admissionGroupId: admissionGroupId
        }, options).$promise;
      }
    }, {
      key: 'listByAdmissionGroupId',
      value: function listByAdmissionGroupId(admissionGroupId) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!admissionGroupId) throw new Error('jsSdk.confirmationRequest - listByAdmissionGroupId() - admissionGroupId is required');

        options.admissionGroupId = admissionGroupId;

        return this._resource.listByAdmissionGroupId(options).$promise;
      }
    }, {
      key: 'performActionById',
      value: function performActionById(id, options) {
        if (!id) throw new Error('jsSdk.confirmationRequest - performActionById() - id is required');

        return this._resource.performActionById({
          id: id
        }, options).$promise;
      }
    }, {
      key: 'cancelById',
      value: function cancelById(id, options) {
        if (!id) throw new Error('jsSdk.confirmationRequest - cancelById() - id is required');

        return this._resource.deleteById({
          id: id
        }, options).$promise;
      }
    }]);

    return ConfirmationRequestService;
  }(CommonService);

  return new ConfirmationRequestService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.confirmationRequest.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/confirmation-request/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Permission = resourceFactory('jsSdk.confirmationRequest.resource', ENDPOINT, PARAM_DEFAULTS, {
    createByAdmissionGroupId: {
      method: 'POST',
      url: '/admission-group/:admissionGroupId/confirmation-request',
      isArray: false
    },
    performActionById: {
      method: 'POST',
      url: ENDPOINT + '/action',
      isArray: false
    },
    listByAdmissionGroupId: {
      method: 'GET',
      url: '/admission-group/:admissionGroupId/confirmation-request',
      isArray: true
    }
  });

  return Permission;
}]);
'use strict';

angular.module('jsSdk').constant('jsSdk.AUTH_TYPES', {
  CONSUMER: 'CONSUMER',
  MANAGEMENT: 'MANAGEMENT'
});
'use strict';

angular.module('jsSdk').constant('jsSdk.HEADERS', {
  TOTAL_COUNT: 'X-Total-Count'
});
'use strict';

angular.module('jsSdk').constant('jsSdk.TRACKING_EVENTS', {

  UserVerifiedPhoneNumber: 'TLUserPhoneVerified',
  UserUpdatedProfilePicture: 'TLUserUpdatedProfilePicture',
  UserCompletedProfile: 'TLUserCompletedProfile',

  CityViewed: 'TLCityViewed',
  CityFeaturedViewed: 'TLCityFeaturedViewed',
  CityTonightViewed: 'TLCityTonightViewed',
  CityThisWeekViewed: 'TLCityThisWeekViewed',
  CityApplied: 'TLCityApplied',
  CityShared: 'TLCityShared',

  VenueViewed: 'TLVenueViewed',
  VenueInfoViewed: 'TLVenueInfoViewed',
  VenueContactViewed: 'TLVenueContactViewed',
  VenueMapViewed: 'TLVenueMapViewed',
  VenueAppliedForAccess: 'TLVenueAppliedForAccess',

  EventViewed: 'TLEventViewed',

  BookingInventoryViewed: 'TLBookingInventoryViewed',
  BookingAddBottlesViewed: 'TLBookingAddBottlesViewed',
  BookingInfoViewed: 'TLBookingInfoViewed',
  BookingReviewViewed: 'TLBookingReviewViewed',
  BookingTermsViewed: 'TLBookingTermsViewed',
  BookingComplete: 'TLBookingComplete',
  BookingReservationComplete: 'TLBookingReservationComplete',
  BookingPromoterComplete: 'TLBookingPromoterComplete',
  BookingFailed: 'TLBookingFailed',
  BookingReservationFailed: 'TLBookingReservationFailed',
  BookingAddedToPassbook: 'TLBookingAddedToPassbook',
  BookingInquiryViewed: 'TLBookingInquiryViewed',
  BookingInquirySubmitted: 'TLBookingInquirySubmitted',

  BookingJoinPending: 'TLBookingJoinPending',
  BookingJoinAccepted: 'TLBookingJoinAccepted',
  BookingJoinCodeSent: 'TLBookingJoinCodeSent',

  BookingReviewSubmitted: 'TLBookingReviewSubmitted',

  FavoritedVenue: 'TLFavoritedVenue',
  FavoritedEvent: 'TLFavoritedEvent',

  ReferralEntered: 'TLReferralEntered',
  ReferralSentFB: 'TLReferralSentFB',
  ReferralSentTW: 'TLReferralSentTW',
  ReferralSentSMS: 'TLReferralSentSMS',
  ReferralSentEmail: 'TLReferralSentEmail',

  SMSDownloadLinkRequested: 'TLSMSDownloadLinkRequested',

  PaymentAdded: 'TLPaymentAdded',
  PaymentUpdated: 'TLPaymentUpdated',

  CodeRedeemed: 'TLPromoCodeRedeemed',

  RewardViewed: 'TLRewardViewed',
  RewardRedeemed: 'TLRewardRedeemed',

  AboutBlogViewed: 'TLAboutBlogViewed',
  AboutFacebookViewed: 'TLAboutFacebookViewed',
  AboutTwitterViewed: 'TLAboutTwitterViewed',
  AboutWebsiteViewed: 'TLAboutWebsiteViewed',

  EasterEggAccountProfilePicture: 'TLEasterEggAccountProfilePicture',

  InventorySearched: 'TLInventorySearched',
  InventorySearchResultSelected: 'TLInventorySearchResultSelected'
});
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.curatedList', ['jsSdk.commonService', 'jsSdk.curatedList.resource', function (CommonService, curatedList) {
  var CuratedListService = function (_CommonService) {
    _inherits(CuratedListService, _CommonService);

    function CuratedListService() {
      _classCallCheck(this, CuratedListService);

      return _possibleConstructorReturn(this, (CuratedListService.__proto__ || Object.getPrototypeOf(CuratedListService)).call(this, curatedList, 'CuratedListService'));
    }

    _createClass(CuratedListService, [{
      key: 'listByCityId',
      value: function listByCityId(cityId, options) {
        if (!cityId) throw new Error('jsSdk.curatedList - listByCityId() - cityId is required');
        options = options || {};

        options.limit = options.limit || this.DEFAULT_LIMIT;
        options.cityId = cityId;

        return this._resource.listByCityId(options).$promise;
      }
    }, {
      key: 'listByVenueId',
      value: function listByVenueId(venueId, options) {
        if (!venueId) throw new Error('jsSdk.curatedList - listByVenueId() - venueId is required');
        options = options || {};

        options.limit = options.limit || this.DEFAULT_LIMIT;
        options.venueId = venueId;

        return this._resource.listByVenueId(options).$promise;
      }
    }, {
      key: 'listByEventId',
      value: function listByEventId(eventId, options) {
        if (!eventId) throw new Error('jsSdk.curatedList - listByEventId() - eventId is required');
        options = options || {};

        options.limit = options.limit || this.DEFAULT_LIMIT;
        options.eventId = eventId;

        return this._resource.listByEventId(options).$promise;
      }
    }, {
      key: 'performActionById',
      value: function performActionById(id, options) {
        if (!id) throw new Error('jsSdk.curatedList - performActionById() - id is required');
        if (!options) throw new Error('jsSdk.curatedList - performActionById() - options is required');
        if (!options.type) throw new Error('jsSdk.curatedList - performActionById() - options.type is required');

        return this._resource.performActionById({
          id: id
        }, options).$promise;
      }
    }, {
      key: 'notifyFollowersById',
      value: function notifyFollowersById(id, options) {
        if (!id) throw new Error('jsSdk.curatedList - notifyFollowersById() - id is required');
        if (!options) throw new Error('jsSdk.curatedList - notifyFollowersById() - options is required');
        if (!options.message) throw new Error('jsSdk.curatedList - notifyFollowersById() - options.message is required');

        options.type = options.type || 'PUSH';

        return this._resource.notifyFollowersById({
          id: id
        }, options).$promise;
      }
    }, {
      key: 'DEFAULT_SORT',
      get: function get() {
        return 'sort';
      }
    }]);

    return CuratedListService;
  }(CommonService);

  return new CuratedListService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.curatedList.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/curated-list/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var CuratedList = resourceFactory('jsSdk.curatedList.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByCityId: {
      method: 'GET',
      url: 'city/:cityId/curated-list',
      isArray: true
    },
    listByVenueId: {
      method: 'GET',
      url: 'venue/:venueId/curated-list',
      isArray: true
    },
    listByEventId: {
      method: 'GET',
      url: 'event/:eventId/curated-list',
      isArray: true
    },
    performActionById: {
      method: 'POST',
      url: ENDPOINT + '/action'
    },
    notifyFollowersById: {
      method: 'POST',
      url: ENDPOINT + '/notification'
    }
  });

  return CuratedList;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.curatedListFollow', ['jsSdk.commonService', 'jsSdk.curatedListFollow.resource', function (CommonService, curatedListFollow) {
  var CuratedListFollowService = function (_CommonService) {
    _inherits(CuratedListFollowService, _CommonService);

    function CuratedListFollowService() {
      _classCallCheck(this, CuratedListFollowService);

      return _possibleConstructorReturn(this, (CuratedListFollowService.__proto__ || Object.getPrototypeOf(CuratedListFollowService)).call(this, curatedListFollow, 'CuratedListFollowService'));
    }

    _createClass(CuratedListFollowService, [{
      key: 'listByCuratedListId',
      value: function listByCuratedListId(curatedListId, options) {
        if (!curatedListId) throw new Error('jsSdk.curatedListFollow - listByCuratedListId() - curatedListId is required');
        options = options || {};

        options.limit = options.limit || this.DEFAULT_LIMIT;
        options.sort = options.sort || this.DEFAULT_SORT;
        options.curatedListId = curatedListId;

        return this._resource.listByCuratedListId(options).$promise;
      }
    }, {
      key: 'listByUserId',
      value: function listByUserId(userId, options) {
        if (!userId) throw new Error('jsSdk.curatedListFollow - listByUserId() - userId is required');
        options = options || {};

        options.limit = options.limit || this.DEFAULT_LIMIT;
        options.sort = options.sort || this.DEFAULT_SORT;
        options.userId = userId;

        return this._resource.listByUserId(options).$promise;
      }
    }, {
      key: 'createByCuratedListId',
      value: function createByCuratedListId(curatedListId, options) {
        if (!curatedListId) throw new Error('jsSdk.curatedListFollow - createByCuratedListId() - curatedListId is required');

        return this._resource.createByCuratedListId({
          curatedListId: curatedListId
        }, options).$promise;
      }
    }, {
      key: 'updateByCuratedListId',
      value: function updateByCuratedListId(curatedListId, options) {
        if (!curatedListId) throw new Error('jsSdk.curatedListFollow - updateByCuratedListId() - curatedListId is required');
        if (!options) throw new Error('jsSdk.curatedListFollow - updateByCuratedListId() - options is required');

        return this._resource.updateByCuratedListId({
          curatedListId: curatedListId
        }, options).$promise;
      }
    }, {
      key: 'removeByCuratedListId',
      value: function removeByCuratedListId(curatedListId, options) {
        if (!curatedListId) throw new Error('jsSdk.curatedListFollow - removeByCuratedListId() - curatedListId is required');
        options = options || {};

        options.curatedListId = curatedListId;

        return this._resource.removeByCuratedListId(options).$promise;
      }
    }]);

    return CuratedListFollowService;
  }(CommonService);

  return new CuratedListFollowService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.curatedListFollow.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/curated-list-follow/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var CuratedListFollow = resourceFactory('jsSdk.curatedListFollow.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByCuratedListId: {
      method: 'GET',
      url: 'curated-list/:curatedListId/follow',
      isArray: true
    },
    listByUserId: {
      method: 'GET',
      url: 'user/:userId/curated-list-follow',
      isArray: true
    },
    createByCuratedListId: {
      method: 'POST',
      url: 'curated-list/:curatedListId/follow'
    },
    updateByCuratedListId: {
      method: 'PUT',
      url: 'curated-list/:curatedListId/follow'
    },
    removeByCuratedListId: {
      method: 'DELETE',
      url: 'curated-list/:curatedListId/follow'
    }
  });

  return CuratedListFollow;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.curatedListItem', ['jsSdk.commonService', 'jsSdk.curatedListItem.resource', function (CommonService, curatedListItem) {
  var CuratedListItemService = function (_CommonService) {
    _inherits(CuratedListItemService, _CommonService);

    function CuratedListItemService() {
      _classCallCheck(this, CuratedListItemService);

      return _possibleConstructorReturn(this, (CuratedListItemService.__proto__ || Object.getPrototypeOf(CuratedListItemService)).call(this, curatedListItem, 'CuratedListItemService'));
    }

    _createClass(CuratedListItemService, [{
      key: 'listByCuratedListId',
      value: function listByCuratedListId(curatedListId, options) {
        if (!curatedListId) throw new Error('jsSdk.curatedListItem - listByCuratedListId() - curatedListId is required');
        options = options || {};

        options.limit = options.limit || this.DEFAULT_LIMIT;
        options.curatedListId = curatedListId;

        return this._resource.listByCuratedListId(options).$promise;
      }
    }, {
      key: 'createByCuratedListId',
      value: function createByCuratedListId(curatedListId, options) {
        if (!curatedListId) throw new Error('jsSdk.curatedListItem - createByCuratedListId() - curatedListId is required');

        return this._resource.createByCuratedListId({
          curatedListId: curatedListId
        }, options).$promise;
      }
    }, {
      key: 'deleteByCuratedListId',
      value: function deleteByCuratedListId(curatedListId, itemId, options) {
        if (!curatedListId) throw new Error('jsSdk.curatedListItem - deleteByCuratedListId() - curatedListId is required');
        if (!itemId) throw new Error('jsSdk.curatedListItem - deleteByCuratedListId() - itemId is required');

        return this._resource.deleteByCuratedListId({
          curatedListId: curatedListId,
          itemId: itemId
        }, options).$promise;
      }
    }, {
      key: 'patchByCuratedListId',
      value: function patchByCuratedListId(curatedListId, itemId, options) {
        if (!curatedListId) throw new Error('jsSdk.curatedListItem - patchByCuratedListId() - curatedListId is required');
        if (!itemId) throw new Error('jsSdk.curatedListItem - patchByCuratedListId() - itemId is required');
        if (!options) throw new Error('jsSdk.curatedListItem - patchByCuratedListId() - options is required');

        return this._resource.patchByCuratedListId({
          curatedListId: curatedListId,
          itemId: itemId
        }, options).$promise;
      }
    }, {
      key: 'performActionByCuratedListId',
      value: function performActionByCuratedListId(curatedListId, itemId, options) {
        if (!curatedListId) throw new Error('jsSdk.curatedListItem - performActionByCuratedListId() - curatedListId is required');
        if (!itemId) throw new Error('jsSdk.curatedListItem - performActionByCuratedListId() - itemId is required');
        if (!options) throw new Error('jsSdk.curatedListItem - performActionByCuratedListId() - options is required');
        if (!options.type) throw new Error('jsSdk.curatedListItem - performActionByCuratedListId() - options.type is required');

        return this._resource.performActionByCuratedListId({
          curatedListId: curatedListId,
          itemId: itemId
        }, options).$promise;
      }
    }]);

    return CuratedListItemService;
  }(CommonService);

  return new CuratedListItemService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.curatedListItem.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/curated-list-item/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var CuratedListItem = resourceFactory('jsSdk.curatedListItem.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByCuratedListId: {
      method: 'GET',
      url: 'curated-list/:curatedListId/item',
      isArray: true
    },
    createByCuratedListId: {
      method: 'POST',
      url: 'curated-list/:curatedListId/item'
    },
    deleteByCuratedListId: {
      method: 'DELETE',
      url: 'curated-list/:curatedListId/item/:itemId'
    },
    patchByCuratedListId: {
      method: 'PATCH',
      url: 'curated-list/:curatedListId/item/:itemId'
    },
    performActionByCuratedListId: {
      method: 'POST',
      url: 'curated-list/:curatedListId/item/:itemId/action'
    }
  });

  return CuratedListItem;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.customer', ['$q', 'jsSdk.HEADERS', 'jsSdk.commonService', 'jsSdk.customer.resource', function ($q, HEADERS, CommonService, customer) {
  var CustomerService = function (_CommonService) {
    _inherits(CustomerService, _CommonService);

    function CustomerService() {
      _classCallCheck(this, CustomerService);

      return _possibleConstructorReturn(this, (CustomerService.__proto__ || Object.getPrototypeOf(CustomerService)).call(this, customer, 'CustomerService'));
    }

    _createClass(CustomerService, [{
      key: 'readByIdAndOrganizationId',
      value: function readByIdAndOrganizationId(id, organizationId, options) {
        if (!id) throw new Error('jsSdk.customer - readByIdAndOrganizationId() - id is required');
        if (!organizationId) throw new Error('jsSdk.customer - readByIdAndOrganizationId() - organizationId is required');
        options = options || {};

        options.id = id;
        options.organizationId = organizationId;

        return this._resource.readByIdAndOrganizationId(options).$promise;
      }
    }, {
      key: 'listByOrganizationId',
      value: function listByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('jsSdk.customer - listByOrganizationId() - organizationId is required');
        options = options || {};

        options.organizationId = organizationId;

        return this._resource.listByOrganizationId(options).$promise;
      }
    }, {
      key: 'queryByOrganizationId',
      value: function queryByOrganizationId(organizationId) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!organizationId) throw new Error('jsSdk.customer - listByOrganizationId() - organizationId is required');
        options.organizationId = organizationId;

        var deferred = $q.defer();
        this._resource.listByOrganizationId(options, function (data, headers) {
          var result = {
            data: data,
            totalCount: headers(HEADERS.TOTAL_COUNT)
          };
          deferred.resolve(result);
        }, deferred.reject);

        return deferred.promise;
      }
    }, {
      key: 'searchByOrganizationId',
      value: function searchByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('jsSdk.customer - searchByOrganizationId() - organizationId is required');
        options = options || {};

        options.organizationId = organizationId;

        return this._resource.searchByOrganizationId(options).$promise;
      }
    }, {
      key: 'createByOrganizationId',
      value: function createByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('jsSdk.customer - createByOrganizationId() - organizationId is required');
        if (!options) throw new Error('jsSdk.customer - createByOrganizationId() - options is required');

        return this._resource.createByOrganizationId({
          organizationId: organizationId
        }, options).$promise;
      }
    }, {
      key: 'updateByIdAndOrganizationId',
      value: function updateByIdAndOrganizationId(id, organizationId, options) {
        if (!id) throw new Error('jsSdk.customer - updateByIdAndOrganizationId() - id is required');
        if (!organizationId) throw new Error('jsSdk.customer - updateByIdAndOrganizationId() - organizationId is required');
        if (!options) throw new Error('jsSdk.customer - updateByIdAndOrganizationId() - options is required');

        return this._resource.updateByIdAndOrganizationId({
          id: id,
          organizationId: organizationId
        }, options).$promise;
      }
    }, {
      key: 'deleteByIdAndOrganizationId',
      value: function deleteByIdAndOrganizationId(id, organizationId) {
        if (!id) throw new Error('jsSdk.customer - deleteByIdAndOrganizationId() - id is required');
        if (!organizationId) throw new Error('jsSdk.customer - deleteByIdAndOrganizationId() - organizationId is required');

        return this._resource.deleteByIdAndOrganizationId({
          id: id,
          organizationId: organizationId
        }).$promise;
      }
    }, {
      key: 'performActionByIdAndOrganizationId',
      value: function performActionByIdAndOrganizationId(id, organizationId, options) {
        if (!id) throw new Error('jsSdk.customer - performActionByIdAndOrganizationId() - id is required');
        if (!organizationId) throw new Error('jsSdk.customer - performActionByIdAndOrganizationId() - organizationId is required');
        if (!options) throw new Error('jsSdk.customer - updateByIdAndOrganizationId() - options is required');

        options.id = id;
        options.organizationId = organizationId;

        return this._resource.performActionByIdAndOrganizationId({
          id: id,
          organizationId: organizationId
        }, options).$promise;
      }
    }]);

    return CustomerService;
  }(CommonService);

  return new CustomerService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.customer.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/customer/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Customer = resourceFactory('jsSdk.customer.resource', ENDPOINT, PARAM_DEFAULTS, {
    readByIdAndOrganizationId: {
      method: 'GET',
      url: 'organization/:organizationId/customer/:id',
      isArray: false
    },
    listByOrganizationId: {
      method: 'GET',
      url: 'organization/:organizationId/customer',
      isArray: true,
      params: {
        organizationId: '@organizationId'
      }
    },
    searchByOrganizationId: {
      method: 'GET',
      url: 'organization/:organizationId/customer/search',
      isArray: true
    },
    createByOrganizationId: {
      method: 'POST',
      url: 'organization/:organizationId/customer',
      isArray: false
    },
    updateByIdAndOrganizationId: {
      method: 'PUT',
      url: 'organization/:organizationId/customer/:id',
      isArray: false
    },
    deleteByIdAndOrganizationId: {
      method: 'DELETE',
      url: 'organization/:organizationId/customer/:id',
      isArray: false
    },
    performActionByIdAndOrganizationId: {
      method: 'POST',
      url: 'organization/:organizationId/customer/:id/action',
      isArray: false
    }
  });

  return Customer;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.dataExport', ['jsSdk.commonService', 'jsSdk.dataExport.resource', function (CommonService, dataExport) {

  var TYPE = {
    CUSTOMER_DUMP: 'CUSTOMER_DUMP',
    GUESTLIST_BY_ATTRIBUTION_SOURCE_DUMP: 'GUESTLIST_BY_ATTRIBUTION_SOURCE_DUMP',
    GUESTLIST_DUMP: 'GUESTLIST_DUMP',
    RESERVATION_BY_ATTRIBUTION_SOURCE_DUMP: 'RESERVATION_BY_ATTRIBUTION_SOURCE_DUMP',
    RESERVATION_DUMP: 'RESERVATION_DUMP'
  };

  var FILE_TYPE = {
    CSV: 'CSV'
  };

  var STATE_TYPE = {
    PENDING: 'PENDING',
    GENERATING: 'GENERATING',
    FAILED: 'FAILED',
    COMPLETE: 'COMPLETE'
  };

  var DataExportService = function (_CommonService) {
    _inherits(DataExportService, _CommonService);

    function DataExportService() {
      _classCallCheck(this, DataExportService);

      return _possibleConstructorReturn(this, (DataExportService.__proto__ || Object.getPrototypeOf(DataExportService)).call(this, dataExport, 'DataExportService'));
    }

    _createClass(DataExportService, [{
      key: 'listByOrganizationMemberId',
      value: function listByOrganizationMemberId(organizationMemberId, options) {
        if (!organizationMemberId) throw new Error('jsSdk.dataExport - listByOrganizationMemberId() - organizationMemberId is required');
        options = options || {};

        options.limit = options.limit || this.DEFAULT_LIMIT;
        options.sort = options.sort || this.DEFAULT_SORT;
        options.organizationMemberId = organizationMemberId;

        return this._resource.listByOrganizationMemberId(options).$promise;
      }
    }, {
      key: 'getDownloadUrlById',
      value: function getDownloadUrlById(dataExportId) {
        if (!dataExportId) throw new Error('jsSdk.dataExport - getDownloadUrlById() - dataExportId is required');

        var options = {
          id: dataExportId
        };

        return this._resource.getDownloadUrlById(options).$promise;
      }
    }, {
      key: 'TYPE',
      get: function get() {
        return TYPE;
      }
    }, {
      key: 'FILE_TYPE',
      get: function get() {
        return FILE_TYPE;
      }
    }, {
      key: 'STATE_TYPE',
      get: function get() {
        return STATE_TYPE;
      }
    }]);

    return DataExportService;
  }(CommonService);

  return new DataExportService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.dataExport.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/data-export/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var DataExport = resourceFactory('jsSdk.dataExport.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByOrganizationMemberId: {
      method: 'GET',
      url: 'organization-member/:organizationMemberId/data-export',
      isArray: true
    },
    getDownloadUrlById: {
      method: 'GET',
      url: ENDPOINT + '/download',
      isArray: false
    }
  });

  return DataExport;
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.daySummary.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/day-summary/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Venue = resourceFactory('jsSdk.daySummary.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByOrganizationIdAndVenueId: {
      method: 'GET',
      url: 'organization/:organizationId/venue/:venueId/day-summary',
      isArray: true
    }
  });

  return Venue;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.daySummary', ['jsSdk.commonService', 'jsSdk.daySummary.resource', function (CommonService, daySummary) {
  var DaySummaryService = function (_CommonService) {
    _inherits(DaySummaryService, _CommonService);

    function DaySummaryService() {
      _classCallCheck(this, DaySummaryService);

      return _possibleConstructorReturn(this, (DaySummaryService.__proto__ || Object.getPrototypeOf(DaySummaryService)).call(this, daySummary, 'DaySummaryService'));
    }

    _createClass(DaySummaryService, [{
      key: 'listByOrganizationIdAndVenueId',
      value: function listByOrganizationIdAndVenueId(organizationId, venueId, options) {
        if (!organizationId) throw new Error('jsSdk.daySummary - listByOrganizationId() - organizationId is required');
        if (!venueId) throw new Error('jsSdk.daySummary - listByOrganizationId() - venueId is required');

        options = options || {};
        options.organizationId = organizationId;
        options.venueId = venueId;
        options.limit = options.limit || this.DEFAULT_LIMIT;
        options.sort = options.sort || this.DEFAULT_SORT;

        return this._resource.listByOrganizationIdAndVenueId(options).$promise;
      }
    }]);

    return DaySummaryService;
  }(CommonService);

  return new DaySummaryService();
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.discount', ['jsSdk.commonService', 'jsSdk.discount.resource', function (CommonService, discount) {
  var DiscountService = function (_CommonService) {
    _inherits(DiscountService, _CommonService);

    function DiscountService() {
      _classCallCheck(this, DiscountService);

      return _possibleConstructorReturn(this, (DiscountService.__proto__ || Object.getPrototypeOf(DiscountService)).call(this, discount, 'DiscountService'));
    }

    _createClass(DiscountService, [{
      key: 'addByIdAndInventoryId',
      value: function addByIdAndInventoryId(id, inventoryId, options) {
        if (!id) throw new Error('jsSdk.discount - addByIdAndInventoryId() - id is required');
        if (!inventoryId) throw new Error('jsSdk.discount - addByIdAndInventoryId() - inventoryId is required');
        options = options || {};

        options.inventoryId = inventoryId;

        return this._resource.addByIdAndInventoryId({
          id: id
        }, options).$promise;
      }
    }, {
      key: 'removeByIdAndInventoryId',
      value: function removeByIdAndInventoryId(id, inventoryId, options) {
        if (!id) throw new Error('jsSdk.discount - removeByIdAndInventoryId() - id is required');
        if (!inventoryId) throw new Error('jsSdk.discount - removeByIdAndInventoryId() - inventoryId is required');

        return this._resource.removeByIdAndInventoryId({
          id: id,
          inventoryId: inventoryId
        }, options).$promise;
      }
    }, {
      key: 'addByIdAndInventoryType',
      value: function addByIdAndInventoryType(id, inventoryType, options) {
        if (!id) throw new Error('jsSdk.discount - addByIdAndInventoryType() - id is required');
        if (!inventoryType) throw new Error('jsSdk.discount - addByIdAndInventoryType() - inventoryType is required');
        options = options || {};

        options.inventoryType = inventoryType;

        return this._resource.addByIdAndInventoryType({
          id: id
        }, options).$promise;
      }
    }, {
      key: 'removeByIdAndInventoryType',
      value: function removeByIdAndInventoryType(id, inventoryType, options) {
        if (!id) throw new Error('jsSdk.discount - removeByIdAndInventoryType() - id is required');
        if (!inventoryType) throw new Error('jsSdk.discount - removeByIdAndInventoryType() - inventoryType is required');

        return this._resource.removeByIdAndInventoryType({
          id: id,
          inventoryType: inventoryType
        }, options).$promise;
      }
    }, {
      key: 'addByIdAndEventId',
      value: function addByIdAndEventId(id, eventId, options) {
        if (!id) throw new Error('jsSdk.discount - addByIdAndEventId() - id is required');
        if (!eventId) throw new Error('jsSdk.discount - addByIdAndEventId() - eventId is required');
        options = options || {};

        options.eventId = eventId;

        return this._resource.addByIdAndEventId({
          id: id
        }, options).$promise;
      }
    }, {
      key: 'removeByIdAndEventId',
      value: function removeByIdAndEventId(id, eventId, options) {
        if (!id) throw new Error('jsSdk.discount - removeEventById() - id is required');
        if (!eventId) throw new Error('jsSdk.discount - removeEventById() - eventId is required');

        return this._resource.removeByIdAndEventId({
          id: id,
          eventId: eventId
        }, options).$promise;
      }
    }, {
      key: 'addByIdAndMembershipPlanId',
      value: function addByIdAndMembershipPlanId(id, membershipPlanId, options) {
        if (!id) throw new Error('jsSdk.discount - addByIdAndMembershipPlanId() - id is required');
        if (!membershipPlanId) throw new Error('jsSdk.discount - addByIdAndMembershipPlanId() - membershipPlanId is required');
        options = options || {};

        options.membershipPlanId = membershipPlanId;

        return this._resource.addByIdAndMembershipPlanId({
          id: id
        }, options).$promise;
      }
    }, {
      key: 'removeByIdAndMembershipPlanId',
      value: function removeByIdAndMembershipPlanId(id, membershipPlanId, options) {
        if (!id) throw new Error('jsSdk.discount - removeByIdAndMembershipPlanId() - id is required');
        if (!membershipPlanId) throw new Error('jsSdk.discount - removeByIdAndMembershipPlanId() - membershipPlanId is required');

        return this._resource.removeByIdAndMembershipPlanId({
          id: id,
          membershipPlanId: membershipPlanId
        }, options).$promise;
      }
    }]);

    return DiscountService;
  }(CommonService);

  return new DiscountService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.discount.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/discount/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Discount = resourceFactory('jsSdk.discount.resource', ENDPOINT, PARAM_DEFAULTS, {
    addByIdAndInventoryId: {
      method: 'POST',
      url: ENDPOINT + '/inventory',
      isArray: false
    },
    removeByIdAndInventoryId: {
      method: 'DELETE',
      url: ENDPOINT + '/inventory/:inventoryId',
      isArray: false
    },
    addByIdAndInventoryType: {
      method: 'POST',
      url: ENDPOINT + '/inventory-type',
      isArray: false
    },
    removeByIdAndInventoryType: {
      method: 'DELETE',
      url: ENDPOINT + '/inventory-type/:inventoryType',
      isArray: false
    },
    addByIdAndEventId: {
      method: 'POST',
      url: ENDPOINT + '/event',
      isArray: false
    },
    removeByIdAndEventId: {
      method: 'DELETE',
      url: ENDPOINT + '/event/:eventId',
      isArray: false
    },
    addByIdAndMembershipPlanId: {
      method: 'POST',
      url: ENDPOINT + '/membership-plan',
      isArray: false
    },
    removeByIdAndMembershipPlanId: {
      method: 'DELETE',
      url: ENDPOINT + '/membership-plan/:membershipPlanId',
      isArray: false
    }
  });

  return Discount;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.event', ['jsSdk.commonService', 'jsSdk.event.resource', function (CommonService, event) {
  var EventService = function (_CommonService) {
    _inherits(EventService, _CommonService);

    function EventService() {
      _classCallCheck(this, EventService);

      return _possibleConstructorReturn(this, (EventService.__proto__ || Object.getPrototypeOf(EventService)).call(this, event, 'EventService'));
    }

    _createClass(EventService, [{
      key: 'listByOrganizationId',
      value: function listByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('jsSdk.event - listByOrganizationId() - organizationId is required');

        options = options || {};
        options.organizationId = organizationId;

        return this._resource.listByOrganizationId(options).$promise;
      }
    }, {
      key: 'performActionById',
      value: function performActionById(id, options) {
        if (!id) throw new Error('jsSdk.event - performActionById() - id is required');

        return this._resource.performActionById({
          id: id
        }, options).$promise;
      }
    }, {
      key: 'createByOrganizationId',
      value: function createByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('jsSdk.event - createByOrganizationId() - organizationId is required');
        if (!options) throw new Error('jsSdk.event - createByOrganizationId() - options is required');

        return this._resource.createByOrganizationId({
          organizationId: organizationId
        }, options).$promise;
      }
    }, {
      key: 'listByVenueId',
      value: function listByVenueId(venueId, options) {
        if (!venueId) throw new Error('jsSdk.event - listByVenueId() - venueId is required');

        options = options || {};
        options.venueId = venueId;

        return this._resource.listByVenueId(options).$promise;
      }
    }, {
      key: 'listByCityId',
      value: function listByCityId(cityId, options) {
        if (!cityId) throw new Error('jsSdk.event - listByCityId() - cityId is required');

        options = options || {};
        options.cityId = cityId;

        return this._resource.listByCityId(options).$promise;
      }
    }]);

    return EventService;
  }(CommonService);

  return new EventService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.event.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/event/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Event = resourceFactory('jsSdk.event.resource', ENDPOINT, PARAM_DEFAULTS, {
    createByOrganizationId: {
      method: 'POST',
      url: 'organization/:organizationId/event',
      isArray: false,
      params: {
        organizationId: '@organizationId'
      }
    },
    performActionById: {
      method: 'POST',
      url: ENDPOINT + '/action',
      isArray: false
    },
    listByVenueId: {
      method: 'GET',
      url: 'venue/:venueId/event',
      isArray: true,
      params: {
        venueId: '@venueId'
      }
    },
    listByCityId: {
      method: 'GET',
      url: '/city/:cityId/event',
      isArray: true,
      params: {
        cityId: '@cityId'
      }
    }
  });

  return Event;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.image', ['$q', '$window', 'jsSdk.http', 'jsSdk.commonService', 'jsSdk.image.resource', function ($q, $window, http, CommonService, image) {

  var MAX_FILE_SIZE = 16000000;

  var ImageService = function (_CommonService) {
    _inherits(ImageService, _CommonService);

    function ImageService() {
      _classCallCheck(this, ImageService);

      return _possibleConstructorReturn(this, (ImageService.__proto__ || Object.getPrototypeOf(ImageService)).call(this, image, 'ImageService'));
    }

    _createClass(ImageService, [{
      key: 'upload',
      value: function upload(file, options) {
        if (!file) throw new Error('jsSdk.image - upload() - file is required');
        if (!$window.FormData) throw new Error('jsSdk.image - upload() - FormData is not supported');
        options = options || {};

        if (file.size > MAX_FILE_SIZE) {
          throw new Error('jsSdk.image - upload() - File cannot be greater than 16mb');
        }

        var formData = new $window.FormData();
        formData.append('image', file);

        var deferred = $q.defer();

        http.upload('/image', options, formData).success(deferred.resolve).error(deferred.reject);

        return deferred.promise;
      }
    }, {
      key: 'listByEventId',
      value: function listByEventId(eventId, options) {
        if (!eventId) throw new Error('jsSdk.image - listByEventId() - eventId is required');

        options = options || {};
        options.limit = options.limit || this.DEFAULT_LIMIT;
        options.sort = options.sort || this.DEFAULT_SORT;
        options.eventId = eventId;

        return this._resource.listByEventId(options).$promise;
      }
    }, {
      key: 'createByEventId',
      value: function createByEventId(eventId, options) {
        if (!eventId) throw new Error('jsSdk.image - createByEventId() - eventId is required');
        if (!options) throw new Error('jsSdk.image - createByEventId() - options is required');

        options.eventId = eventId;

        return this._resource.createByEventId(options).$promise;
      }
    }, {
      key: 'deleteByEventId',
      value: function deleteByEventId(id, eventId, options) {
        if (!id) throw new Error('jsSdk.image - deleteByEventId() - id is required');
        if (!eventId) throw new Error('jsSdk.image - deleteByEventId() - eventId is required');

        options = options || {};
        options.id = id;
        options.eventId = eventId;

        return this._resource.deleteByEventId(options).$promise;
      }
    }, {
      key: 'setPrimaryByEventId',
      value: function setPrimaryByEventId(id, eventId, options) {
        if (!id) throw new Error('jsSdk.image - setPrimaryByEventId() - id is required');
        if (!eventId) throw new Error('jsSdk.image - setPrimaryByEventId() - eventId is required');

        options = options || {};
        options.id = id;
        options.eventId = eventId;

        return this._resource.setPrimaryByEventId(options).$promise;
      }
    }]);

    return ImageService;
  }(CommonService);

  return new ImageService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.image.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/image/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Image = resourceFactory('jsSdk.image.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByEventId: {
      method: 'GET',
      url: 'event/:eventId/image',
      isArray: true,
      params: {
        eventId: '@eventId'
      }
    },
    createByEventId: {
      method: 'POST',
      url: 'event/:eventId/image',
      isArray: true,
      params: {
        eventId: '@eventId'
      }
    },
    deleteByEventId: {
      method: 'DELETE',
      url: 'event/:eventId/image/:id',
      isArray: true,
      params: {
        eventId: '@eventId'
      }
    },
    setPrimaryByEventId: {
      method: 'PUT',
      url: '/event/:eventId/image/:id',
      isArray: true,
      params: {
        eventId: '@eventId'
      }
    }
  });

  return Image;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.inquiry', ['jsSdk.commonService', 'jsSdk.inquiry.resource', function (CommonService, inquiry) {
  var InquiryService = function (_CommonService) {
    _inherits(InquiryService, _CommonService);

    function InquiryService() {
      _classCallCheck(this, InquiryService);

      return _possibleConstructorReturn(this, (InquiryService.__proto__ || Object.getPrototypeOf(InquiryService)).call(this, inquiry, 'InquiryService'));
    }

    _createClass(InquiryService, [{
      key: 'create',
      value: function create(options) {
        if (!options) throw new Error('jsSdk.inquiry - create() - options is required');
        return this._resource.create(options).$promise;
      }
    }, {
      key: 'approve',
      value: function approve(id, options) {
        if (!id) throw new Error('jsSdk.inquiry - approve() - id is required');
        options = options || {};

        return this._resource.approve({
          id: id
        }, options).$promise;
      }
    }, {
      key: 'decline',
      value: function decline(id, options) {
        if (!id) throw new Error('jsSdk.inquiry - decline() - id is required');
        options = options || {};

        return this._resource.decline({
          id: id
        }, options).$promise;
      }
    }]);

    return InquiryService;
  }(CommonService);

  return new InquiryService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.inquiry.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/inquiry/:id';

  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Inquiry = resourceFactory('jsSdk.inquiry.resource', ENDPOINT, PARAM_DEFAULTS, {
    create: {
      method: 'POST',
      url: '/inquiry'
    },
    list: {
      method: 'GET',
      url: '/inquiry',
      isArray: true
    },
    approve: {
      method: 'POST',
      url: ENDPOINT + '/approve'
    },
    decline: {
      method: 'POST',
      url: ENDPOINT + '/decline'
    }
  });

  return Inquiry;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.internalNote', ['jsSdk.commonService', 'jsSdk.internalNote.resource', function (CommonService, internalNote) {
  var LayoutTableService = function (_CommonService) {
    _inherits(LayoutTableService, _CommonService);

    function LayoutTableService() {
      _classCallCheck(this, LayoutTableService);

      return _possibleConstructorReturn(this, (LayoutTableService.__proto__ || Object.getPrototypeOf(LayoutTableService)).call(this, internalNote, 'LayoutTableService'));
    }

    _createClass(LayoutTableService, [{
      key: 'listByVenueId',
      value: function listByVenueId(venueId, options) {
        if (!venueId) throw new Error('jsSdk.internalNote - listByVenueId() - venueId is required');
        options = options || {};

        options.venueId = venueId;

        return this._resource.listByVenueId(options).$promise;
      }
    }]);

    return LayoutTableService;
  }(CommonService);

  return new LayoutTableService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.internalNote.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/internal-note/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var LayoutTable = resourceFactory('jsSdk.internalNote.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByVenueId: {
      method: 'GET',
      url: 'venue/:venueId/internal-note',
      isArray: true
    }
  });

  return LayoutTable;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.inventory', ['jsSdk.commonService', 'jsSdk.inventory.resource', function (CommonService, inventory) {
  var InventoryService = function (_CommonService) {
    _inherits(InventoryService, _CommonService);

    function InventoryService() {
      _classCallCheck(this, InventoryService);

      return _possibleConstructorReturn(this, (InventoryService.__proto__ || Object.getPrototypeOf(InventoryService)).call(this, inventory, 'InventoryService'));
    }

    _createClass(InventoryService, [{
      key: 'listByVenueId',
      value: function listByVenueId(venueId, options) {
        if (!venueId) throw new Error('jsSdk.inventory - listByVenueId() - venueId is required');

        options = options || {};
        options.venueId = venueId;

        return this._resource.listByVenueId(options).$promise;
      }
    }, {
      key: 'performActionById',
      value: function performActionById(id, options) {
        if (!id) throw new Error('jsSdk.inventory - performActionById() - id is required');
        if (!options) throw new Error('jsSdk.inventory - performActionById() - options is required');
        if (!options.type) throw new Error('jsSdk.inventory - performActionById() - options.type is required');

        return this._resource.performActionById({
          id: id
        }, options).$promise;
      }
    }, {
      key: 'createTierById',
      value: function createTierById(id, options) {
        if (!id) throw new Error('jsSdk.inventory - createTierById() - id is required');
        if (!options) throw new Error('jsSdk.inventory - createTierById() - options is required');

        return this._resource.createTierById({
          id: id
        }, options).$promise;
      }
    }, {
      key: 'updateTierById',
      value: function updateTierById(id, tierId, options) {
        if (!id) throw new Error('jsSdk.inventory - updateTierById() - id is required');
        if (!tierId) throw new Error('jsSdk.inventory - updateTierById() - tierId is required');
        if (!options) throw new Error('jsSdk.inventory - updateTierById() - options is required');

        return this._resource.updateTierById({
          id: id,
          tierId: tierId
        }, options).$promise;
      }
    }, {
      key: 'deleteTierById',
      value: function deleteTierById(id, tierId, options) {
        if (!id) throw new Error('jsSdk.inventory - deleteTierById() - id is required');
        if (!tierId) throw new Error('jsSdk.inventory - deleteTierById() - tierId is required');

        return this._resource.deleteTierById({
          id: id,
          tierId: tierId
        }, options).$promise;
      }
    }]);

    return InventoryService;
  }(CommonService);

  return new InventoryService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.inventory.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/inventory/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Inventory = resourceFactory('jsSdk.inventory.resource', ENDPOINT, PARAM_DEFAULTS, {
    create: {
      method: 'POST',
      url: ENDPOINT
    },
    listByVenueId: {
      method: 'GET',
      url: 'venue/:venueId/active-inventory',
      isArray: true,
      params: {
        venueId: '@venueId'
      }
    },
    listPromosById: {
      method: 'GET',
      url: ENDPOINT + '/promo',
      isArray: true
    },
    addPromoById: {
      method: 'POST',
      url: ENDPOINT + '/promo',
      isArray: false
    },
    removePromoById: {
      method: 'DELETE',
      url: ENDPOINT + '/promo/:promoId',
      isArray: false
    },
    performActionById: {
      method: 'POST',
      url: ENDPOINT + '/action'
    },
    createTierById: {
      method: 'POST',
      url: ENDPOINT + '/tier',
      isArray: false
    },
    updateTierById: {
      method: 'PUT',
      url: ENDPOINT + '/tier/:tierId',
      isArray: false
    },
    deleteTierById: {
      method: 'DELETE',
      url: ENDPOINT + '/tier/:tierId',
      isArray: false
    }
  });

  return Inventory;
}]);
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.inventorySummary', ['jsSdk.commonService', 'jsSdk.inventorySummary.resource', function (CommonService, inventorySummary) {
  var InventorySummaryService = function (_CommonService) {
    _inherits(InventorySummaryService, _CommonService);

    function InventorySummaryService() {
      _classCallCheck(this, InventorySummaryService);

      return _possibleConstructorReturn(this, (InventorySummaryService.__proto__ || Object.getPrototypeOf(InventorySummaryService)).call(this, inventorySummary, 'InventorySummaryService'));
    }

    return InventorySummaryService;
  }(CommonService);

  return new InventorySummaryService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.inventorySummary.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/inventory-summary';
  var PARAM_DEFAULTS = {};

  var Inventory = resourceFactory('jsSdk.inventorySummary.resource', ENDPOINT, PARAM_DEFAULTS, {});

  return Inventory;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.item', ['jsSdk.commonService', 'jsSdk.item.resource', function (CommonService, item) {
  var ItemService = function (_CommonService) {
    _inherits(ItemService, _CommonService);

    function ItemService() {
      _classCallCheck(this, ItemService);

      return _possibleConstructorReturn(this, (ItemService.__proto__ || Object.getPrototypeOf(ItemService)).call(this, item, 'ItemService'));
    }

    _createClass(ItemService, [{
      key: 'listByVenueId',
      value: function listByVenueId(venueId, options) {
        if (!venueId) throw new Error('jsSdk.VenueDiscount - listByVenueId() - venueId is required');

        options = options || {};
        options.venueId = venueId;

        return this._resource.listByVenueId(options).$promise;
      }
    }]);

    return ItemService;
  }(CommonService);

  return new ItemService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.item.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/item/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Item = resourceFactory('jsSdk.item.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByVenueId: {
      method: 'GET',
      url: '/venue/:venueId/item',
      isArray: true,
      params: {
        venueId: '@venueId'
      }
    }
  });

  return Item;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.layout', ['jsSdk.commonService', 'jsSdk.layout.resource', function (CommonService, layout) {
  var LayoutService = function (_CommonService) {
    _inherits(LayoutService, _CommonService);

    function LayoutService() {
      _classCallCheck(this, LayoutService);

      return _possibleConstructorReturn(this, (LayoutService.__proto__ || Object.getPrototypeOf(LayoutService)).call(this, layout, 'LayoutService'));
    }

    _createClass(LayoutService, [{
      key: 'listByVenueId',
      value: function listByVenueId(venueId, options) {
        if (!venueId) throw new Error('jsSdk.layout - listByVenueId() - venueId is required');
        options = options || {};

        options.venueId = venueId;

        return this._resource.listByVenueId(options).$promise;
      }
    }]);

    return LayoutService;
  }(CommonService);

  return new LayoutService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.layout.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/venue-layout/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Layout = resourceFactory('jsSdk.layout.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByVenueId: {
      method: 'GET',
      url: 'venue/:venueId/layout',
      isArray: true
    }
  });

  return Layout;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.layoutSection', ['jsSdk.commonService', 'jsSdk.layoutSection.resource', function (CommonService, layoutSection) {
  var LayoutSectionService = function (_CommonService) {
    _inherits(LayoutSectionService, _CommonService);

    function LayoutSectionService() {
      _classCallCheck(this, LayoutSectionService);

      return _possibleConstructorReturn(this, (LayoutSectionService.__proto__ || Object.getPrototypeOf(LayoutSectionService)).call(this, layoutSection, 'LayoutSectionService'));
    }

    _createClass(LayoutSectionService, [{
      key: 'listByVenueId',
      value: function listByVenueId(venueId, options) {
        if (!venueId) throw new Error('jsSdk.layoutSection - listByVenueId() - venueId is required');
        options = options || {};

        options.venueId = venueId;

        return this._resource.listByVenueId(options).$promise;
      }
    }]);

    return LayoutSectionService;
  }(CommonService);

  return new LayoutSectionService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.layoutSection.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/venue-layout-section/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var LayoutSection = resourceFactory('jsSdk.layoutSection.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByVenueId: {
      method: 'GET',
      url: 'venue/:venueId/layout-section',
      isArray: true
    }
  });

  return LayoutSection;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.layoutTable', ['jsSdk.commonService', 'jsSdk.layoutTable.resource', function (CommonService, layoutTable) {
  var LayoutTableService = function (_CommonService) {
    _inherits(LayoutTableService, _CommonService);

    function LayoutTableService() {
      _classCallCheck(this, LayoutTableService);

      return _possibleConstructorReturn(this, (LayoutTableService.__proto__ || Object.getPrototypeOf(LayoutTableService)).call(this, layoutTable, 'LayoutTableService'));
    }

    _createClass(LayoutTableService, [{
      key: 'listByVenueId',
      value: function listByVenueId(venueId, options) {
        if (!venueId) throw new Error('jsSdk.layoutTable - listByVenueId() - venueId is required');
        options = options || {};

        options.venueId = venueId;

        return this._resource.listByVenueId(options).$promise;
      }
    }]);

    return LayoutTableService;
  }(CommonService);

  return new LayoutTableService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.layoutTable.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/venue-layout-table/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var LayoutTable = resourceFactory('jsSdk.layoutTable.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByVenueId: {
      method: 'GET',
      url: 'venue/:venueId/layout-table',
      isArray: true
    }
  });

  return LayoutTable;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('jsSdk').service('jsSdk.browserSupportUtils', [function () {
  var BrowserSupportUtils = function () {
    function BrowserSupportUtils() {
      _classCallCheck(this, BrowserSupportUtils);
    }

    _createClass(BrowserSupportUtils, [{
      key: 'cookies',
      value: function cookies() {
        var cookieEnabled = navigator.cookieEnabled ? true : false;

        if (typeof navigator.cookieEnabled === 'undefined' && !cookieEnabled) {
          document.cookie = 'testcookie';
          cookieEnabled = document.cookie.indexOf('testcookie') !== -1 ? true : false;
        }

        return cookieEnabled;
      }
    }, {
      key: 'localstorage',
      value: function localstorage() {
        var mod = 'modernizr';
        try {
          localStorage.setItem(mod, mod);
          localStorage.removeItem(mod);
          return true;
        } catch (e) {
          return false;
        }
      }
    }]);

    return BrowserSupportUtils;
  }();

  return new BrowserSupportUtils();
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('jsSdk').service('jsSdk.cache', ['$cacheFactory', function ($cacheFactory) {
  var DEFAULT_CACHE_TYPE = '$http';

  var Cache = function () {
    function Cache() {
      _classCallCheck(this, Cache);
    }

    _createClass(Cache, [{
      key: 'remove',
      value: function remove(key) {
        if (!key) throw new Error('jsSdk.cache - remove() - key is required');

        var cache = _getDefaultCache();

        if (!cache) return false;

        cache.remove(key);

        return true;
      }
    }, {
      key: 'removeAll',
      value: function removeAll() {
        var cache = _getDefaultCache();

        if (!cache) return false;

        cache.removeAll();

        return true;
      }
    }, {
      key: 'size',
      get: function get() {
        var cache = _getDefaultCache();

        if (!cache) return 0;

        return cache.info() ? cache.info().size : 0;
      }
    }]);

    return Cache;
  }();

  function _getDefaultCache() {
    return $cacheFactory.get(DEFAULT_CACHE_TYPE);
  }

  return new Cache();
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('jsSdk').service('jsSdk.cookie', ['jsSdk.config', '$cookies', function (config, $cookies) {
  var DOMAIN = 'tablelist.com';

  var Cookie = function () {
    function Cookie() {
      _classCallCheck(this, Cookie);
    }

    _createClass(Cookie, [{
      key: 'get',
      value: function get(key) {
        if (!key) throw new Error('jsSdk.cookie - get() - key is required');

        return $cookies.get(key);
      }
    }, {
      key: 'set',
      value: function set(key, value) {
        if (!key) throw new Error('jsSdk.cookie - set() - key is required');
        if (!value) throw new Error('jsSdk.cookie - set() - value is required');

        var domain = config.enableCookieDomain || false;
        var secure = config.enableSecureCookie || false;

        var expires = 'Fri, 31 Dec 9999 23:59:59 GMT';

        $cookies.put(key, value, {
          domain: domain ? DOMAIN : null,
          secure: secure,
          expires: expires
        });

        return true;
      }
    }, {
      key: 'remove',
      value: function remove(key) {
        if (!key) throw new Error('jsSdk.cookie - remove() - key is required');

        var domain = config.enableCookieDomain || false;
        var secure = config.enableSecureCookie || false;

        var expires = 'Thu, 01 Jan 1970 00:00:00 GMT';

        $cookies.remove(key, {
          domain: domain ? DOMAIN : null,
          secure: secure,
          expires: expires
        });

        return true;
      }
    }]);

    return Cookie;
  }();

  return new Cookie();
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('jsSdk').service('jsSdk.eventEmitter', ['$rootScope', function ($rootScope) {
  var EventEmitter = function () {
    function EventEmitter(eventNamespace) {
      _classCallCheck(this, EventEmitter);

      if (!eventNamespace) throw new Error('jsSdk.eventEmitter - constructor - eventNamespace is required');
      this._eventNamespace = eventNamespace;
    }

    _createClass(EventEmitter, [{
      key: 'on',
      value: function on(eventName, handler) {
        if (!eventName) throw new Error('jsSdk.eventEmitter - on() - eventName is required');
        if (!handler) throw new Error('jsSdk.eventEmitter - on() - handler is required');

        $rootScope.$on(this._eventNamespace, function (event, eventMessage) {
          if (eventMessage && eventMessage.event === eventName) {
            return handler(eventMessage.message);
          }
        });

        return null;
      }
    }, {
      key: 'emit',
      value: function emit(eventName, message) {
        if (!eventName) throw new Error('jsSdk.eventEmitter - emit() - eventName is required');

        $rootScope.$emit(this._eventNamespace, {
          event: eventName,
          message: message
        });

        return null;
      }
    }]);

    return EventEmitter;
  }();

  return EventEmitter;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('jsSdk').service('jsSdk.http', ['$http', 'jsSdk.config', function ($http, sdkConfig) {
  var Http = function () {
    function Http() {
      _classCallCheck(this, Http);
    }

    _createClass(Http, [{
      key: 'get',
      value: function get(endpoint, params) {
        if (!endpoint) throw new Error('jsSdk.http - get - endpoint is required');
        return $http.get(this.getApiUrl(endpoint, params));
      }
    }, {
      key: 'post',
      value: function post(endpoint, body, options) {
        if (!endpoint) throw new Error('jsSdk.http - post - endpoint is required');
        return $http.post(this.getApiUrl(endpoint), body, options);
      }
    }, {
      key: 'put',
      value: function put(endpoint, body, options) {
        if (!endpoint) throw new Error('jsSdk.http - put - endpoint is required');
        return $http.put(this.getApiUrl(endpoint), body, options);
      }
    }, {
      key: 'patch',
      value: function patch(endpoint, body, options) {
        if (!endpoint) throw new Error('jsSdk.http - patch - endpoint is required');
        return $http.patch(this.getApiUrl(endpoint), body, options);
      }
    }, {
      key: 'delete',
      value: function _delete(endpoint, params) {
        if (!endpoint) throw new Error('jsSdk.http - delete - endpoint is required');
        return $http.delete(this.getApiUrl(endpoint, params));
      }
    }, {
      key: 'upload',
      value: function upload(endpoint, params, body) {
        if (!endpoint) throw new Error('jsSdk.http - upload - endpoint is required');
        return $http.post(this.getApiUrl(endpoint, params), body, {
          headers: {
            'Content-Type': undefined
          },
          transformRequest: angular.identity
        });
      }
    }, {
      key: 'getApiUrl',
      value: function getApiUrl(endpoint, params) {
        if (!endpoint) throw new Error('jsSdk.http - getApiUrl - endpoint is required');
        params = params || {};

        var queryStringParams = [];
        for (var key in params) {
          key = encodeURIComponent(key);
          var value = encodeURIComponent(params[key]);
          queryStringParams.push(key + '=' + value);
        }

        if (endpoint.slice(0, 1) === '/') endpoint = endpoint.substring(1, endpoint.length);

        var url = sdkConfig.apiBaseUrl + '/' + endpoint;

        if (queryStringParams.length > 0) {
          queryStringParams = queryStringParams.join('&');
          url += '?' + queryStringParams;
        }

        return url;
      }
    }]);

    return Http;
  }();

  return new Http();
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('jsSdk').service('jsSdk.httpInterceptor', ['jsSdk.config', 'jsSdk.keychain', function (config, keychain) {
  var CONSUMER_AUTH_HEADER = 'x-access-token';
  var MANAGEMENT_AUTH_HEADER = 'x-access-management-token';
  var PROSPECT_AUTH_HEADER = 'x-prospect-token';
  var CLIENT_AUTH_HEADER = 'x-client-type';

  var HttpIntercepter = function () {
    function HttpIntercepter() {
      _classCallCheck(this, HttpIntercepter);
    }

    _createClass(HttpIntercepter, [{
      key: 'request',
      value: function request(data) {
        data = data || {};

        data.headers = data.headers || {};

        if (data.url) {
          var consumerAuthToken = keychain.getConsumerAuthToken();
          var managementAuthToken = keychain.getManagementAuthToken();

          var isApi = _urlIsApiUrl(data.url);
          var queryStringParams = {};

          if (isApi) {
            if (consumerAuthToken) {
              data.headers[CONSUMER_AUTH_HEADER] = consumerAuthToken;
            } else if (managementAuthToken) {
              data.headers[MANAGEMENT_AUTH_HEADER] = managementAuthToken;
            } else {
              var prospectToken = keychain.getProspectToken();
              data.headers[PROSPECT_AUTH_HEADER] = prospectToken;
            }

            if (config.apiKey) {
              data.headers['api-key'] = config.apiKey;
            }

            if (config.client) {
              var client = config.client;
              if (config.subClient) client = client + '-' + config.subClient;
              data.headers[CLIENT_AUTH_HEADER] = client;
            }

            queryStringParams.version = config.version;
          }

          data.url = _addQueryStringParamsToUrl(data.url, queryStringParams);
        }

        return data;
      }
    }]);

    return HttpIntercepter;
  }();

  function _urlIsApiUrl(url) {
    if (!url) return false;
    return url.indexOf(config.apiBaseUrl) >= 0;
  }

  function _addQueryStringParamsToUrl(url, params) {
    if (!url || !params) return url;

    var seperator = url.indexOf('?') >= 0 ? '&' : '?';

    for (var key in params) {
      url += '' + seperator + key + '=' + params[key];
      seperator = '&';
    }

    return url;
  }

  return new HttpIntercepter();
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('jsSdk').service('jsSdk.imgix', ['$window', function ($window) {
  var Imgix = function () {
    function Imgix() {
      _classCallCheck(this, Imgix);
    }

    _createClass(Imgix, [{
      key: 'url',
      value: function url(src, options) {
        if (!src) throw new Error('jsSdk.imgix - url - src is required');

        var path = src.filename || src;

        options = options || {};
        options.fit = options.fit || this.fit.crop;
        options.quality = options.quality || this.quality.medium;
        options.format = options.format || this.format.jpeg;

        if (path.indexOf('imgix') < 0) return path;

        var url = path.split('?')[0];

        var params = ['dpr=' + this.pixelDensity];

        if (options.width) {
          params.push('w=' + options.width);
        }

        if (options.height) {
          params.push('h=' + options.height);
        }

        if (options.format) {
          params.push('fm=' + options.format);
        }

        if (options.fit) {
          params.push('fit=' + options.fit);
        }

        if (options.quality) {
          params.push('q=' + options.quality);
        }

        return url + '?' + params.join('&');
      }
    }, {
      key: 'fit',
      get: function get() {
        return {
          crop: 'crop'
        };
      }
    }, {
      key: 'format',
      get: function get() {
        return {
          png: 'png',
          jpeg: 'jpg'
        };
      }
    }, {
      key: 'quality',
      get: function get() {
        return {
          low: 25,
          medium: 50,
          high: 75,
          original: 100
        };
      }
    }, {
      key: 'pixelDensity',
      get: function get() {
        return $window.devicePixelRatio || 1.0;
      }
    }]);

    return Imgix;
  }();

  return new Imgix();
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('jsSdk').service('jsSdk.keychain', ['jsSdk.config', 'jsSdk.cookie', 'jsSdk.localstorage', 'jsSdk.utils', 'jsSdk.browserSupportUtils', function (config, cookie, localstorage, utils, browserSupportUtils) {
  var consumerAuthToken = void 0;
  var managementAuthToken = void 0;
  var prospectToken = void 0;

  var Keychain = function () {
    function Keychain() {
      _classCallCheck(this, Keychain);
    }

    _createClass(Keychain, [{
      key: 'getConsumerAuthToken',
      value: function getConsumerAuthToken() {
        if (consumerAuthToken) return consumerAuthToken;

        return _getKey(config.consumerAuthTokenKey);
      }
    }, {
      key: 'setConsumerAuthToken',
      value: function setConsumerAuthToken(token) {
        if (!token) throw new Error('jsSdk.keychain - setConsumerAuthToken - token is required');

        var value = _setKey(config.consumerAuthTokenKey, token);

        consumerAuthToken = value;

        return value;
      }
    }, {
      key: 'removeConsumerAuthToken',
      value: function removeConsumerAuthToken() {
        consumerAuthToken = null;

        return _removeKey(config.consumerAuthTokenKey);
      }
    }, {
      key: 'getManagementAuthToken',
      value: function getManagementAuthToken() {
        if (managementAuthToken) return managementAuthToken;

        return _getKey(config.managementAuthTokenKey);
      }
    }, {
      key: 'setManagementAuthToken',
      value: function setManagementAuthToken(token) {
        if (!token) throw new Error('jsSdk.keychain - setManagementAuthToken - token is required');

        var value = _setKey(config.managementAuthTokenKey, token);

        managementAuthToken = value;

        return value;
      }
    }, {
      key: 'removeManagementAuthToken',
      value: function removeManagementAuthToken() {
        managementAuthToken = null;

        return _removeKey(config.managementAuthTokenKey);
      }
    }, {
      key: 'getProspectToken',
      value: function getProspectToken() {
        if (prospectToken) return prospectToken;

        var token = _getKey(config.prospectTokenKey);

        if (!token) {
          token = utils.guid(16, '-');
          this.setPropsectToken(token);
        }

        return token;
      }
    }, {
      key: 'setPropsectToken',
      value: function setPropsectToken(token) {
        if (!token) throw new Error('jsSdk.keychain - setPropsectToken - token is required');

        var value = _setKey(config.prospectTokenKey, token);

        prospectToken = value;

        return value;
      }
    }, {
      key: 'removeProspectToken',
      value: function removeProspectToken() {
        prospectToken = null;

        return _removeKey(config.prospectTokenKey);
      }
    }]);

    return Keychain;
  }();

  function _getKey(key) {
    key = _genKey(key);
    if (browserSupportUtils.cookies()) {
      return cookie.get(key);
    } else if (browserSupportUtils.localstorage()) {
      return localstorage.get(key);
    }
  }

  function _setKey(key, value) {
    key = _genKey(key);
    if (browserSupportUtils.cookies()) {
      cookie.set(key, value);
    } else if (browserSupportUtils.localstorage()) {
      localstorage.set(key, value);
    }

    return value;
  }

  function _removeKey(key) {
    key = _genKey(key);
    if (browserSupportUtils.cookies()) {
      return cookie.remove(key);
    } else if (browserSupportUtils.localstorage()) {
      return localstorage.remove(key);
    }
  }

  function _genKey(key) {
    if (!config.cookiePrefix) return key;
    return config.cookiePrefix + '_' + key;
  }

  return new Keychain();
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('jsSdk').service('jsSdk.localstorage', ['$window', function ($window) {
  var CACHE = {};

  var LocalStorage = function () {
    function LocalStorage() {
      _classCallCheck(this, LocalStorage);
    }

    _createClass(LocalStorage, [{
      key: 'get',
      value: function get(key) {
        if (!key) throw new Error('jsSdk.localstorage - get() - key is required');

        var json = void 0;

        try {
          var val = $window.localStorage.getItem(key);
          if (val) json = JSON.parse(val);
        } catch (e) {}

        if (!json) json = CACHE[key];

        return json;
      }
    }, {
      key: 'set',
      value: function set(key, value) {
        if (!key) throw new Error('jsSdk.localstorage - set() - key is required');
        if (!value) throw new Error('jsSdk.localstorage - set() - value is required');

        if (value) {
          try {
            var val = JSON.stringify(value);
            $window.localStorage.setItem(key, val);
          } catch (e) {
            CACHE[key] = value;
          }

          return null;
        } else {
          this.remove(key);
        }
      }
    }, {
      key: 'remove',
      value: function remove(key) {
        if (!key) throw new Error('jsSdk.localstorage - remove() - key is required');

        try {
          $window.localStorage.removeItem(key);
        } catch (e) {
          delete CACHE[key];
        }

        return null;
      }
    }, {
      key: 'exists',
      value: function exists(key) {
        if (!key) throw new Error('jsSdk.localstorage - exists() - key is required');

        var exists = null;

        try {
          exists = this.get(key) !== null && this.get(key) !== undefined;
        } catch (e) {
          exists = CACHE[key] ? true : false;
        }

        return exists;
      }
    }, {
      key: 'clear',
      value: function clear() {
        var cleared = null;

        try {
          cleared = $window.localStorage.clear();
        } catch (e) {
          CACHE = {};
          cleared = true;
        }

        return cleared;
      }
    }]);

    return LocalStorage;
  }();

  return new LocalStorage();
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('jsSdk').service('jsSdk.query', ['$location', function ($location) {
  var Query = function () {
    function Query() {
      _classCallCheck(this, Query);
    }

    _createClass(Query, [{
      key: 'params',
      value: function params() {
        return $location.search() || {};
      }
    }, {
      key: 'get',
      value: function get(key) {
        if (!key) throw new Error('jsSdk.query - get() - key is required');

        var params = this.params();

        return params[key] || null;
      }
    }, {
      key: 'set',
      value: function set(key, value) {
        if (!key) throw new Error('jsSdk.query - set() - key is required');
        if (!value) throw new Error('jsSdk.query - set() - value is required');

        var params = this.params();

        params[key] = value;

        $location.search(key, value);

        return value;
      }
    }, {
      key: 'subdomain',
      value: function subdomain() {
        return $location.hostname && $location.hostname.length ? $location.hostname.split('.')[0] : null;
      }
    }]);

    return Query;
  }();

  return new Query();
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('jsSdk').service('jsSdk.urlUtils', ['jsSdk.keychain', 'jsSdk.config', function (keychain, config) {
  var UrlUtils = function () {
    function UrlUtils() {
      _classCallCheck(this, UrlUtils);
    }

    _createClass(UrlUtils, [{
      key: 'endpointToApiUrl',
      value: function endpointToApiUrl(endpoint, params) {
        if (!endpoint) throw new Error('jsSdk.testUtils - endpointToApiUrl() - endpoint is required');

        var queryParams = [];
        var url = config.apiBaseUrl + endpoint;

        queryParams.push({
          name: 'version',
          value: config.version
        });

        for (var key in params) {
          queryParams.push({
            name: key,
            value: params[key]
          });
        }

        for (var i = 0; i < queryParams.length; i++) {
          var param = queryParams[i];

          if (i === 0) {
            url += '?';
          } else {
            url += '&';
          }

          url += param.name + '=' + param.value;
        }

        return url;
      }
    }]);

    return UrlUtils;
  }();

  return new UrlUtils();
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('jsSdk').service('jsSdk.utils', [function () {
  var Utils = function () {
    function Utils() {
      _classCallCheck(this, Utils);
    }

    _createClass(Utils, [{
      key: 'guid',
      value: function guid() {
        return _s4() + _s4() + '-' + _s4() + '-' + _s4() + '-' + _s4() + '-' + _s4() + _s4() + _s4();
      }
    }, {
      key: 'getErrorFromResponse',
      value: function getErrorFromResponse(response) {
        var error = 'An error has occurred. Please try again or contact hello@tablelist.com for support.';

        if (response && response.message) {
          error = response.message;
        } else if (response && response.errors && response.errors[0] && response.errors[0].message) {
          error = response.errors[0].message;
        } else if (response && response.data && response.data.errors && response.data.errors[0] && response.data.errors[0].message) {
          error = response.data.errors[0].message;
        }

        return error;
      }
    }, {
      key: 'onlyDigits',
      value: function onlyDigits(text) {
        if (!text) return null;
        text = text + '';
        return text.replace(/\D/g, '').trim();
      }
    }]);

    return Utils;
  }();

  function _s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  return new Utils();
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.managementUser', ['$timeout', '$q', 'jsSdk.commonService', 'jsSdk.managementUser.resource', 'jsSdk.keychain', 'jsSdk.localstorage', function ($timeout, $q, CommonService, managementUserResource, keychain, localstorage) {

  var USER_KEY = 'tablelist.com_management_user';
  var EVENTS = {
    USER_UPDATED: 'USER_UPDATED'
  };

  var ManagementUserService = function (_CommonService) {
    _inherits(ManagementUserService, _CommonService);

    function ManagementUserService() {
      _classCallCheck(this, ManagementUserService);

      return _possibleConstructorReturn(this, (ManagementUserService.__proto__ || Object.getPrototypeOf(ManagementUserService)).call(this, managementUserResource, 'ManagementManagementUserService'));
    }

    _createClass(ManagementUserService, [{
      key: 'getCurrentUser',
      value: function getCurrentUser() {
        var authToken = keychain.getManagementAuthToken();
        return authToken ? localstorage.get(USER_KEY) : null;
      }
    }, {
      key: 'setCurrentUser',
      value: function setCurrentUser(user) {
        if (!user) throw new Error('jsSdk.managementUser - setCurrentUser() - user is required');
        localstorage.set(USER_KEY, user);
        this.emit(this.EVENTS.USER_UPDATED, user);
        return user;
      }
    }, {
      key: 'updateMe',
      value: function updateMe(options) {
        var _this2 = this;

        if (!options) throw new Error('jsSdk.managementUser - updateMe() - options is required');

        return this._resource.updateMe(options).$promise.then(function (updatedUser) {
          localstorage.set(USER_KEY, updatedUser);
          _this2.emit(_this2.EVENTS.USER_UPDATED, updatedUser);
          return updatedUser;
        });
      }
    }, {
      key: 'removeCurrentUser',
      value: function removeCurrentUser() {
        localstorage.remove(USER_KEY);

        return true;
      }
    }, {
      key: 'me',
      value: function me(options) {
        var _this3 = this;

        var deferred = $q.defer();

        this._resource.me(options).$promise.then(function (user) {
          _this3.setCurrentUser(user);

          return deferred.resolve(user);
        }).catch(deferred.reject);

        return deferred.promise;
      }
    }, {
      key: 'EVENTS',
      get: function get() {
        return EVENTS;
      }
    }]);

    return ManagementUserService;
  }(CommonService);

  return new ManagementUserService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.managementUser.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/management-user/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var User = resourceFactory('jsSdk.managementUser.resource', ENDPOINT, PARAM_DEFAULTS, {
    me: {
      method: 'GET',
      url: '/management-user/me',
      isArray: false
    },
    updateMe: {
      method: 'PUT',
      url: '/management-user/me',
      isArray: false
    }
  });

  return User;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.membership', ['$timeout', '$q', 'jsSdk.commonService', 'jsSdk.membership.resource', function ($timeout, $q, CommonService, membershipResource) {

  var ACTION_TYPE = {
    ADD_BALANCE: 'ADD_BALANCE',
    UPDATE_PAYMENT_METHOD: 'UPDATE_PAYMENT_METHOD',
    CHARGE_PAST_DUE: 'CHARGE_PAST_DUE',
    CANCEL_END_OF_BILLING: 'CANCEL_END_OF_BILLING',
    CANCEL: 'CANCEL'
  };

  var MembershipService = function (_CommonService) {
    _inherits(MembershipService, _CommonService);

    function MembershipService() {
      _classCallCheck(this, MembershipService);

      return _possibleConstructorReturn(this, (MembershipService.__proto__ || Object.getPrototypeOf(MembershipService)).call(this, membershipResource, 'MembershipService'));
    }

    _createClass(MembershipService, [{
      key: 'create',
      value: function create(options) {
        if (!options) throw new Error('jsSdk.membership - create() - options is required');
        if (!options.userId) throw new Error('jsSdk.membership - create() - options.userId is required');
        if (!options.planId) throw new Error('jsSdk.membership - create() - options.planId is required');
        if (!options.paymentProfileId) throw new Error('jsSdk.membership - create() - options.paymentProfileId is required');

        return this._resource.create(options).$promise;
      }
    }, {
      key: 'listByUserId',
      value: function listByUserId(id, options) {
        if (!id) throw new Error('jsSdk.membership - listByUserId() - id is required');

        options = options || {};
        options.userId = id;

        return this._resource.listByUserId(options).$promise;
      }
    }, {
      key: 'listPreview',
      value: function listPreview(options) {
        return this._resource.listPreview(options).$promise;
      }
    }, {
      key: 'membershipCheckout',
      value: function membershipCheckout(planId, options) {
        if (!planId) throw new Error('jsSdk.membership - membershipCheckout() - planId is required');

        options = options || {};
        options.planId = planId;
        return this._resource.membershipCheckout(options).$promise;
      }
    }, {
      key: 'performAction',
      value: function performAction(id, action, options) {
        if (!id) throw new Error('jsSdk.membership - performAction() - membership id is required');
        if (!action) throw new Error('jsSdk.membership - performAction() - action is required');

        options = options || {};
        options.id = id;
        options.type = action;

        return this._resource.action(options).$promise;
      }
    }, {
      key: 'updatePaymentMethod',
      value: function updatePaymentMethod(id, options) {
        if (!id) throw new Error('jsSdk.membership - updatePaymentMethod() - membership id is required');
        if (!options) throw new Error('jsSdk.membership - updatePaymentMethod() - options is required');
        if (!options.paymentProfileId) throw new Error('jsSdk.membership - updatePaymentMethod() - options.paymentProfileId is required');

        return this.performAction(id, ACTION_TYPE.UPDATE_PAYMENT_METHOD, options);
      }
    }, {
      key: 'chargePastDue',
      value: function chargePastDue(id, options) {
        if (!id) throw new Error('jsSdk.membership - chargePastDue() - id is required');

        return this.performAction(id, ACTION_TYPE.CHARGE_PAST_DUE, options);
      }
    }, {
      key: 'cancelEndOfBilling',
      value: function cancelEndOfBilling(id, options) {
        if (!id) throw new Error('jsSdk.membership - cancelEndOfBilling() - id is required');

        return this.performAction(id, ACTION_TYPE.CANCEL_END_OF_BILLING, options);
      }
    }, {
      key: 'cancel',
      value: function cancel(id, options) {
        if (!id) throw new Error('jsSdk.membership - cancel() - id is required');

        return this.performAction(id, ACTION_TYPE.CANCEL, options);
      }
    }, {
      key: 'addBalance',
      value: function addBalance(id, options) {
        if (!id) throw new Error('jsSdk.membership - addBalance() - id is required');
        if (!options) throw new Error('jsSdk.membership - addBalance() - options is required');
        if (!options.balanceAmount) throw new Error('jsSdk.membership - addBalance() - options.balanceAmount is required');

        return this.performAction(id, ACTION_TYPE.ADD_BALANCE, options);
      }
    }, {
      key: 'ACTION_TYPE',
      get: function get() {
        return ACTION_TYPE;
      }
    }]);

    return MembershipService;
  }(CommonService);

  return new MembershipService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.membership.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/membership/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Membership = resourceFactory('jsSdk.membership.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByUserId: {
      method: 'GET',
      url: '/user/:userId/membership',
      isArray: true
    },
    listPreview: {
      method: 'GET',
      url: '/membership-preview',
      isArray: true
    },
    action: {
      method: 'POST',
      url: '/membership/:id/action'
    },
    membershipCheckout: {
      method: 'POST',
      url: '/membership-checkout'
    }
  });
  return Membership;
}]);
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.membershipPlan', ['$timeout', '$q', 'jsSdk.commonService', 'jsSdk.membershipPlan.resource', function ($timeout, $q, CommonService, membershipPlanResource) {
  var MembershipPlanService = function (_CommonService) {
    _inherits(MembershipPlanService, _CommonService);

    function MembershipPlanService() {
      _classCallCheck(this, MembershipPlanService);

      return _possibleConstructorReturn(this, (MembershipPlanService.__proto__ || Object.getPrototypeOf(MembershipPlanService)).call(this, membershipPlanResource, 'MembershipPlanService'));
    }

    return MembershipPlanService;
  }(CommonService);

  return new MembershipPlanService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.membershipPlan.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/membership-plan';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var MembershipPlan = resourceFactory('jsSdk.membershipPlan.resource', ENDPOINT, PARAM_DEFAULTS, {});

  return MembershipPlan;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.membershipReferral', ['$timeout', '$q', 'jsSdk.commonService', 'jsSdk.membershipReferral.resource', function ($timeout, $q, CommonService, membershipReferralResource) {
  var MembershipReferralService = function (_CommonService) {
    _inherits(MembershipReferralService, _CommonService);

    function MembershipReferralService() {
      _classCallCheck(this, MembershipReferralService);

      return _possibleConstructorReturn(this, (MembershipReferralService.__proto__ || Object.getPrototypeOf(MembershipReferralService)).call(this, membershipReferralResource, 'MembershipReferralService'));
    }

    _createClass(MembershipReferralService, [{
      key: 'listByUserId',
      value: function listByUserId(id, options) {
        if (!id) throw new Error('jsSdk.membershipReferral - listByUserId() - id is required');

        options = options || {};
        options.userId = id;

        return this._resource.listByUserId(options).$promise;
      }
    }, {
      key: 'list',
      value: function list(options) {
        return this._resource.list(options).$promise;
      }
    }]);

    return MembershipReferralService;
  }(CommonService);

  return new MembershipReferralService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.membershipReferral.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/membership-referral/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var MembershipReferral = resourceFactory('jsSdk.membershipReferral.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByUserId: {
      method: 'GET',
      url: '/user/:userId/membership-referral',
      isArray: true
    },
    list: {
      method: 'GET',
      url: '/membership-referral',
      isArray: true
    }
  });

  return MembershipReferral;
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.microSiteConfig.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/micro-site-config/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Venue = resourceFactory('jsSdk.microSiteConfig.resource', ENDPOINT, PARAM_DEFAULTS, {
    createByOrganizationId: {
      method: 'POST',
      url: 'organization/:organizationId/micro-site-config',
      isArray: false
    },
    updateByIdAndOrganizationId: {
      method: 'PUT',
      url: 'organization/:organizationId/micro-site-config/:id',
      isArray: false
    },
    listByOrganizationId: {
      method: 'GET',
      url: 'organization/:organizationId/micro-site-config',
      isArray: true
    }
  });

  return Venue;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.microSiteConfig', ['jsSdk.commonService', 'jsSdk.microSiteConfig.resource', function (CommonService, microSiteConfig) {
  var MicroSiteConfigService = function (_CommonService) {
    _inherits(MicroSiteConfigService, _CommonService);

    function MicroSiteConfigService() {
      _classCallCheck(this, MicroSiteConfigService);

      return _possibleConstructorReturn(this, (MicroSiteConfigService.__proto__ || Object.getPrototypeOf(MicroSiteConfigService)).call(this, microSiteConfig, 'MicroSiteConfigService'));
    }

    _createClass(MicroSiteConfigService, [{
      key: 'createByOrganizationId',
      value: function createByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('jsSdk.microSiteConfig - createByOrganizationId() - organizationId is required');
        if (!options) throw new Error('jsSdk.microSiteConfig - createByOrganizationId() - options is required');

        return this._resource.createByOrganizationId({
          organizationId: organizationId
        }, options).$promise;
      }
    }, {
      key: 'updateByIdAndOrganizationId',
      value: function updateByIdAndOrganizationId(id, organizationId, options) {
        if (!id) throw new Error('jsSdk.microSiteConfig - updateByIdAndOrganizationId() - id is required');
        if (!organizationId) throw new Error('jsSdk.microSiteConfig - updateByIdAndOrganizationId() - organizationId is required');
        if (!options) throw new Error('jsSdk.microSiteConfig - updateByIdAndOrganizationId() - options is required');

        return this._resource.updateByIdAndOrganizationId({
          id: id,
          organizationId: organizationId
        }, options).$promise;
      }
    }, {
      key: 'listByOrganizationId',
      value: function listByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('jsSdk.microSiteConfig - listByOrganizationId() - organizationId is required');

        options = options || {};
        options.organizationId = organizationId;
        options.limit = options.limit || this.DEFAULT_LIMIT;
        options.sort = options.sort || this.DEFAULT_SORT;

        return this._resource.listByOrganizationId(options).$promise;
      }
    }]);

    return MicroSiteConfigService;
  }(CommonService);

  return new MicroSiteConfigService();
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.notificationSetting', ['jsSdk.commonService', 'jsSdk.notificationSetting.resource', function (CommonService, notificationSetting) {
  var OrganizationService = function (_CommonService) {
    _inherits(OrganizationService, _CommonService);

    function OrganizationService() {
      _classCallCheck(this, OrganizationService);

      return _possibleConstructorReturn(this, (OrganizationService.__proto__ || Object.getPrototypeOf(OrganizationService)).call(this, notificationSetting, 'OrganizationService'));
    }

    _createClass(OrganizationService, [{
      key: 'listByOrganizationMemberId',
      value: function listByOrganizationMemberId(organizationMemberId, options) {
        if (!organizationMemberId) throw new Error('jsSdk.notificationSetting - listByOrganizationMemberId() - organizationMemberId is required');
        options = options || {};

        options.organizationMemberId = organizationMemberId;

        return this._resource.listByOrganizationMemberId(options).$promise;
      }
    }, {
      key: 'createByOrganizationMemberId',
      value: function createByOrganizationMemberId(organizationMemberId, options) {
        if (!organizationMemberId) throw new Error('jsSdk.notificationSetting - createByOrganizationMemberId() - organizationMemberId is required');
        if (!options) throw new Error('jsSdk.notificationSetting - createByOrganizationMemberId() - options is required');

        return this._resource.createByOrganizationMemberId({
          organizationMemberId: organizationMemberId
        }, options).$promise;
      }
    }, {
      key: 'updateByIdAndByOrganizationMemberId',
      value: function updateByIdAndByOrganizationMemberId(id, organizationMemberId, options) {
        if (!id) throw new Error('jsSdk.notificationSetting - updateByIdAndByOrganizationMemberId() - id is required');
        if (!organizationMemberId) throw new Error('jsSdk.notificationSetting - updateByIdAndByOrganizationMemberId() - organizationMemberId is required');
        if (!options) throw new Error('jsSdk.notificationSetting - updateByIdAndByOrganizationMemberId() - options is required');

        return this._resource.updateByIdAndByOrganizationMemberId({
          id: id,
          organizationMemberId: organizationMemberId
        }, options).$promise;
      }
    }]);

    return OrganizationService;
  }(CommonService);

  return new OrganizationService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.notificationSetting.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/notification-setting/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Organization = resourceFactory('jsSdk.notificationSetting.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByOrganizationMemberId: {
      method: 'GET',
      url: 'organization-member/:organizationMemberId/notification-setting',
      isArray: true
    },
    createByOrganizationMemberId: {
      method: 'POST',
      url: 'organization-member/:organizationMemberId/notification-setting',
      isArray: false
    },
    updateByIdAndByOrganizationMemberId: {
      method: 'PUT',
      url: 'organization-member/:organizationMemberId/notification-setting/:id',
      isArray: false
    }
  });

  return Organization;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.organization', ['jsSdk.commonService', 'jsSdk.organization.resource', function (CommonService, organization) {
  var OrganizationService = function (_CommonService) {
    _inherits(OrganizationService, _CommonService);

    function OrganizationService() {
      _classCallCheck(this, OrganizationService);

      return _possibleConstructorReturn(this, (OrganizationService.__proto__ || Object.getPrototypeOf(OrganizationService)).call(this, organization, 'OrganizationService'));
    }

    _createClass(OrganizationService, [{
      key: 'listByManagementUserId',
      value: function listByManagementUserId(managementUserId, options) {
        if (!managementUserId) throw new Error('jsSdk.organization - listByManagementUserId() - managementUserId is required');
        options = options || {};

        options.limit = options.limit || this.DEFAULT_LIMIT;
        options.sort = options.sort || this.DEFAULT_SORT;
        options.managementUserId = managementUserId;

        return this._resource.listByManagementUserId(options).$promise;
      }
    }, {
      key: 'createByManagementUserId',
      value: function createByManagementUserId(managementUserId, options) {
        if (!managementUserId) throw new Error('jsSdk.organization - createByManagementUserId() - managementUserId is required');
        if (!options) throw new Error('jsSdk.organization - createByManagementUserId() - options is required');

        return this._resource.createByManagementUserId({
          managementUserId: managementUserId
        }, options).$promise;
      }
    }]);

    return OrganizationService;
  }(CommonService);

  return new OrganizationService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.organization.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/organization/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Organization = resourceFactory('jsSdk.organization.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByManagementUserId: {
      method: 'GET',
      url: 'management-user/:managementUserId/organization',
      isArray: true
    },
    createByManagementUserId: {
      method: 'POST',
      url: 'management-user/:managementUserId/organization',
      isArray: false
    }
  });

  return Organization;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.organizationMember', ['jsSdk.commonService', 'jsSdk.organizationMember.resource', function (CommonService, organizationMember) {

  var TYPE = {
    STAFF: 'STAFF',
    SERVER: 'SERVER'
  };

  var OrganizationMemberService = function (_CommonService) {
    _inherits(OrganizationMemberService, _CommonService);

    function OrganizationMemberService() {
      _classCallCheck(this, OrganizationMemberService);

      return _possibleConstructorReturn(this, (OrganizationMemberService.__proto__ || Object.getPrototypeOf(OrganizationMemberService)).call(this, organizationMember, 'OrganizationMemberService'));
    }

    _createClass(OrganizationMemberService, [{
      key: 'readByIdAndOrganizationId',
      value: function readByIdAndOrganizationId(id, organizationId, options) {
        if (!id) throw new Error('jsSdk.organizationMember - readByIdAndOrganizationId() - id is required');
        if (!organizationId) throw new Error('jsSdk.organizationMember - readByIdAndOrganizationId() - organizationId is required');
        options = options || {};

        options.id = id;
        options.organizationId = organizationId;

        return this._resource.readByIdAndOrganizationId(options).$promise;
      }
    }, {
      key: 'listByManagementUserId',
      value: function listByManagementUserId(managementUserId, options) {
        if (!managementUserId) throw new Error('jsSdk.organizationMember - listByManagementUserId() - managementUserId is required');
        options = options || {};

        options.managementUserId = managementUserId;

        return this._resource.listByManagementUserId(options).$promise;
      }
    }, {
      key: 'listByOrganizationId',
      value: function listByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('jsSdk.organizationMember - listByOrganizationId() - organizationId is required');
        options = options || {};

        options.organizationId = organizationId;

        return this._resource.listByOrganizationId(options).$promise;
      }
    }, {
      key: 'createByOrganizationId',
      value: function createByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('jsSdk.organizationMember - createByOrganizationId() - organizationId is required');
        if (!options) throw new Error('jsSdk.organizationMember - createByOrganizationId() - options is required');

        return this._resource.createByOrganizationId({
          organizationId: organizationId
        }, options).$promise;
      }
    }, {
      key: 'updateByIdAndOrganizationId',
      value: function updateByIdAndOrganizationId(id, organizationId, options) {
        if (!id) throw new Error('jsSdk.organizationMember - updateByIdAndOrganizationId() - id is required');
        if (!organizationId) throw new Error('jsSdk.organizationMember - updateByIdAndOrganizationId() - organizationId is required');
        if (!options) throw new Error('jsSdk.organizationMember - updateByIdAndOrganizationId() - options is required');

        return this._resource.updateByIdAndOrganizationId({
          id: id,
          organizationId: organizationId
        }, options).$promise;
      }
    }, {
      key: 'deleteByIdAndOrganizationId',
      value: function deleteByIdAndOrganizationId(id, organizationId) {
        if (!id) throw new Error('jsSdk.organizationMember - deleteByIdAndOrganizationId() - id is required');
        if (!organizationId) throw new Error('jsSdk.organizationMember - deleteByIdAndOrganizationId() - organizationId is required');

        return this._resource.deleteByIdAndOrganizationId({
          id: id,
          organizationId: organizationId
        }).$promise;
      }
    }, {
      key: 'TYPE',
      get: function get() {
        return TYPE;
      }
    }]);

    return OrganizationMemberService;
  }(CommonService);

  return new OrganizationMemberService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.organizationMember.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/organization-member/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var OrganizationMember = resourceFactory('jsSdk.organizationMember.resource', ENDPOINT, PARAM_DEFAULTS, {
    readByIdAndOrganizationId: {
      method: 'GET',
      url: 'organization/:organizationId/member/:id',
      isArray: false
    },
    listByManagementUserId: {
      method: 'GET',
      url: 'management-user/:managementUserId/organization-member',
      isArray: true
    },
    listByOrganizationId: {
      method: 'GET',
      url: 'organization/:organizationId/member',
      isArray: true
    },
    createByOrganizationId: {
      method: 'POST',
      url: 'organization/:organizationId/member',
      isArray: false
    },
    updateByIdAndOrganizationId: {
      method: 'PUT',
      url: 'organization/:organizationId/member/:id',
      isArray: false
    },
    deleteByIdAndOrganizationId: {
      method: 'DELETE',
      url: 'organization/:organizationId/member/:id',
      isArray: false
    }
  });

  return OrganizationMember;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.organizationPermission', ['jsSdk.commonService', 'jsSdk.organizationPermission.resource', function (CommonService, organizationPermission) {
  var OrganizationMemberPermissionService = function (_CommonService) {
    _inherits(OrganizationMemberPermissionService, _CommonService);

    function OrganizationMemberPermissionService() {
      _classCallCheck(this, OrganizationMemberPermissionService);

      return _possibleConstructorReturn(this, (OrganizationMemberPermissionService.__proto__ || Object.getPrototypeOf(OrganizationMemberPermissionService)).call(this, organizationPermission, 'OrganizationPermissionService'));
    }

    _createClass(OrganizationMemberPermissionService, [{
      key: 'listByOrganizationMemberId',
      value: function listByOrganizationMemberId(organizationId, memberId, options) {
        if (!organizationId) throw new Error('jsSdk.organizationPermission - listByOrganizationMemberId() - organizationId is required');
        if (!memberId) throw new Error('jsSdk.organizationPermission - listByOrganizationMemberId() - memberId is required');
        options = options || {};

        options.organizationId = organizationId;
        options.memberId = memberId;

        return this._resource.listByOrganizationMemberId(options).$promise;
      }
    }, {
      key: 'createByOrganizationMemberId',
      value: function createByOrganizationMemberId(organizationId, memberId, options) {
        if (!organizationId) throw new Error('jsSdk.organizationPermission - createByOrganizationMemberId() - organizationId is required');
        if (!memberId) throw new Error('jsSdk.organizationPermission - createByOrganizationMemberId() - memberId is required');
        if (!options) throw new Error('jsSdk.organizationPermission - createByOrganizationMemberId() - options is required');

        return this._resource.createByOrganizationMemberId({
          organizationId: organizationId,
          memberId: memberId
        }, options).$promise;
      }
    }, {
      key: 'createByOrganizationIdAndRelationshipId',
      value: function createByOrganizationIdAndRelationshipId(organizationId, relationshipId, options) {
        if (!organizationId) throw new Error('jsSdk.organizationPermission - createByOrganizationIdAndRelationshipId() - organizationId is required');
        if (!relationshipId) throw new Error('jsSdk.organizationPermission - createByOrganizationIdAndRelationshipId() - relationshipId is required');
        if (!options) throw new Error('jsSdk.organizationPermission - createByOrganizationIdAndRelationshipId() - options is required');

        return this._resource.createByOrganizationIdAndRelationshipId({
          organizationId: organizationId,
          relationshipId: relationshipId
        }, options).$promise;
      }
    }, {
      key: 'deleteByRelationshipIdAndPermissionId',
      value: function deleteByRelationshipIdAndPermissionId(relationshipId, permissionId, options) {
        if (!relationshipId) throw new Error('jsSdk.organizationPermission - deleteByRelationshipIdAndPermissionId() - relationshipId is required');
        if (!permissionId) throw new Error('jsSdk.organizationPermission - deleteByRelationshipIdAndPermissionId() - permissionId is required');

        options = options || {};
        options.relationshipId = relationshipId;
        options.permissionId = permissionId;

        return this._resource.deleteByRelationshipIdAndPermissionId(options).$promise;
      }
    }, {
      key: 'deleteByOrganizationIdAndPermissionId',
      value: function deleteByOrganizationIdAndPermissionId(organizationId, permissionId, options) {
        if (!organizationId) throw new Error('jsSdk.organizationPermission - deleteByOrganizationIdAndPermissionId() - organizationId is required');
        if (!permissionId) throw new Error('jsSdk.organizationPermission - deleteByOrganizationIdAndPermissionId() - permissionId is required');

        options = options || {};
        options.organizationId = organizationId;
        options.permissionId = permissionId;

        return this._resource.deleteByOrganizationIdAndPermissionId(options).$promise;
      }
    }, {
      key: 'listByManagementUserId',
      value: function listByManagementUserId(managementUserId, options) {
        if (!managementUserId) throw new Error('jsSdk.organizationPermission - listByManagementUserId() - managementUserId is required');
        options = options || {};

        options.limit = options.limit || this.DEFAULT_LIMIT;
        options.sort = options.sort || this.DEFAULT_SORT;
        options.managementUserId = managementUserId;

        return this._resource.listByManagementUserId(options).$promise;
      }
    }]);

    return OrganizationMemberPermissionService;
  }(CommonService);

  return new OrganizationMemberPermissionService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.organizationPermission.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/organization-permission/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var OrganizationMemberPermission = resourceFactory('jsSdk.organizationPermission.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByOrganizationMemberId: {
      method: 'GET',
      url: 'organization/:organizationId/member/:memberId/permission',
      isArray: true
    },
    createByOrganizationMemberId: {
      method: 'POST',
      url: 'organization/:organizationId/member/:memberId/permission',
      isArray: false
    },
    createByOrganizationIdAndRelationshipId: {
      method: 'POST',
      url: 'organization/:organizationId/relationship/:relationshipId/permission',
      isArray: false
    },
    deleteByRelationshipIdAndPermissionId: {
      method: 'DELETE',
      url: 'organization-relationship/:relationshipId/permission/:permissionId',
      isArray: false
    },
    deleteByOrganizationIdAndPermissionId: {
      method: 'DELETE',
      url: 'organization/:organizationId/permission/:permissionId',
      isArray: false
    },
    listByManagementUserId: {
      method: 'GET',
      url: 'management-user/:managementUserId/permission',
      isArray: true
    }
  });

  return OrganizationMemberPermission;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.organizationIntegration', ['jsSdk.commonService', 'jsSdk.organizationIntegration.resource', function (CommonService, organizationIntegration) {
  var OrganizationIntegrationService = function (_CommonService) {
    _inherits(OrganizationIntegrationService, _CommonService);

    function OrganizationIntegrationService() {
      _classCallCheck(this, OrganizationIntegrationService);

      return _possibleConstructorReturn(this, (OrganizationIntegrationService.__proto__ || Object.getPrototypeOf(OrganizationIntegrationService)).call(this, organizationIntegration, 'OrganizationPermissionService'));
    }

    _createClass(OrganizationIntegrationService, [{
      key: 'listByOrganizationId',
      value: function listByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('jsSdk.organizationIntegration - listByOrganizationId() - organizationId is required');
        options = options || {};

        options.organizationId = organizationId;

        return this._resource.listByOrganizationId(options).$promise;
      }
    }, {
      key: 'readByIdAndOrganizationId',
      value: function readByIdAndOrganizationId(id, organizationId, options) {
        if (!id) throw new Error('jsSdk.organizationIntegration - readByIdAndOrganizationId() - id is required');
        if (!organizationId) throw new Error('jsSdk.organizationIntegration - readByIdAndOrganizationId() - organizationId is required');
        options = options || {};

        options.id = id;
        options.organizationId = organizationId;

        return this._resource.readByIdAndOrganizationId(options).$promise;
      }
    }, {
      key: 'createByOrganizationId',
      value: function createByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('jsSdk.organizationIntegration - createByOrganizationId() - organizationId is required');
        if (!options) throw new Error('jsSdk.organizationIntegration - createByOrganizationId() - options is required');

        return this._resource.createByOrganizationId({
          organizationId: organizationId
        }, options).$promise;
      }
    }, {
      key: 'updateByIdAndOrganizationId',
      value: function updateByIdAndOrganizationId(id, organizationId, options) {
        if (!id) throw new Error('jsSdk.organizationIntegration - updateByIdAndOrganizationId() - id is required');
        if (!organizationId) throw new Error('jsSdk.organizationIntegration - updateByIdAndOrganizationId() - organizationId is required');

        return this._resource.updateByIdAndOrganizationId({
          id: id,
          organizationId: organizationId
        }, options).$promise;
      }
    }]);

    return OrganizationIntegrationService;
  }(CommonService);

  return new OrganizationIntegrationService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.organizationIntegration.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/organization-integrations/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var OrganizationRelationship = resourceFactory('jsSdk.organizationIntegration.resource', ENDPOINT, PARAM_DEFAULTS, {
    readByIdAndOrganizationId: {
      method: 'GET',
      url: '/v1/organizations/:organizationId/integrations/:id',
      isArray: false
    },
    listByOrganizationId: {
      method: 'GET',
      url: '/v1/organizations/:organizationId/integrations',
      isArray: false
    },
    createByOrganizationId: {
      method: 'POST',
      url: '/v1/organizations/:organizationId/integrations',
      isArray: false
    },
    updateByIdAndOrganizationId: {
      method: 'PUT',
      url: '/v1/organizations/:organizationId/integrations/:id',
      isArray: false
    }
  });

  return OrganizationRelationship;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.organizationRelationship', ['jsSdk.commonService', 'jsSdk.organizationRelationship.resource', function (CommonService, organizationRelationship) {
  var OrganizationRelationshipService = function (_CommonService) {
    _inherits(OrganizationRelationshipService, _CommonService);

    function OrganizationRelationshipService() {
      _classCallCheck(this, OrganizationRelationshipService);

      return _possibleConstructorReturn(this, (OrganizationRelationshipService.__proto__ || Object.getPrototypeOf(OrganizationRelationshipService)).call(this, organizationRelationship, 'OrganizationPermissionService'));
    }

    _createClass(OrganizationRelationshipService, [{
      key: 'listByOrganizationId',
      value: function listByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('jsSdk.organizationRelationship - listByOrganizationId() - organizationId is required');
        options = options || {};

        options.organizationId = organizationId;

        return this._resource.listByOrganizationId(options).$promise;
      }
    }, {
      key: 'readByIdAndOrganizationId',
      value: function readByIdAndOrganizationId(id, organizationId, options) {
        if (!id) throw new Error('jsSdk.organizationRelationship - readByIdAndOrganizationId() - id is required');
        if (!organizationId) throw new Error('jsSdk.organizationRelationship - readByIdAndOrganizationId() - organizationId is required');
        options = options || {};

        options.id = id;
        options.organizationId = organizationId;

        return this._resource.readByIdAndOrganizationId(options).$promise;
      }
    }, {
      key: 'createByOrganizationId',
      value: function createByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('jsSdk.organizationRelationship - createByOrganizationId() - organizationId is required');
        if (!options) throw new Error('jsSdk.organizationRelationship - createByOrganizationId() - options is required');

        return this._resource.createByOrganizationId({
          organizationId: organizationId
        }, options).$promise;
      }
    }, {
      key: 'deleteByIdAndOrganizationId',
      value: function deleteByIdAndOrganizationId(id, organizationId) {
        if (!id) throw new Error('jsSdk.organizationRelationship - deleteByIdAndOrganizationId() - id is required');
        if (!organizationId) throw new Error('jsSdk.organizationRelationship - deleteByIdAndOrganizationId() - organizationId is required');

        return this._resource.deleteByIdAndOrganizationId({
          id: id,
          organizationId: organizationId
        }).$promise;
      }
    }]);

    return OrganizationRelationshipService;
  }(CommonService);

  return new OrganizationRelationshipService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.organizationRelationship.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/organization-relationship/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var OrganizationRelationship = resourceFactory('jsSdk.organizationRelationship.resource', ENDPOINT, PARAM_DEFAULTS, {
    readByIdAndOrganizationId: {
      method: 'GET',
      url: 'organization/:organizationId/relationship/:id',
      isArray: false
    },
    listByOrganizationId: {
      method: 'GET',
      url: '/organization/:organizationId/relationship',
      isArray: true
    },
    createByOrganizationId: {
      method: 'POST',
      url: 'organization/:organizationId/relationship',
      isArray: false
    },
    deleteByIdAndOrganizationId: {
      method: 'DELETE',
      url: 'organization/:organizationId/relationship/:id',
      isArray: false
    }
  });

  return OrganizationRelationship;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.outgoingPayment', ['jsSdk.commonService', 'jsSdk.outgoingPayment.resource', function (CommonService, outgoingPayment) {
  var OutgoingPaymentService = function (_CommonService) {
    _inherits(OutgoingPaymentService, _CommonService);

    function OutgoingPaymentService() {
      _classCallCheck(this, OutgoingPaymentService);

      return _possibleConstructorReturn(this, (OutgoingPaymentService.__proto__ || Object.getPrototypeOf(OutgoingPaymentService)).call(this, outgoingPayment, 'OutgoingPaymentService'));
    }

    _createClass(OutgoingPaymentService, [{
      key: 'listByBookingId',
      value: function listByBookingId(bookingId, options) {
        if (!bookingId) throw new Error('jsSdk.outgoingPayment - listByBookingId() - bookingId is required');
        options = options || {};

        options.bookingId = bookingId;

        return this._resource.listByBookingId(options).$promise;
      }
    }, {
      key: 'listByAdmissionGroupId',
      value: function listByAdmissionGroupId(admissionGroupId, options) {
        if (!admissionGroupId) throw new Error('jsSdk.outgoingPayment - listByAdmissionGroupId() - admissionGroupId is required');
        options = options || {};

        options.admissionGroupId = admissionGroupId;

        return this._resource.listByAdmissionGroupId(options).$promise;
      }
    }]);

    return OutgoingPaymentService;
  }(CommonService);

  return new OutgoingPaymentService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.outgoingPayment.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/outgoing-payment/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var OutgoingPayment = resourceFactory('jsSdk.outgoingPayment.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByBookingId: {
      method: 'GET',
      url: 'booking/:bookingId/outgoing-payment',
      isArray: true,
      params: {
        bookingId: '@bookingId'
      }
    },
    listByAdmissionGroupId: {
      method: 'GET',
      url: 'admission-group/:admissionGroupId/outgoing-payment',
      isArray: true,
      params: {
        admissionGroupId: '@admissionGroupId'
      }
    }
  });

  return OutgoingPayment;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.paymentProfile', ['jsSdk.commonService', 'jsSdk.paymentProfile.resource', function (CommonService, paymentProfile) {
  var PaymentProfileService = function (_CommonService) {
    _inherits(PaymentProfileService, _CommonService);

    function PaymentProfileService() {
      _classCallCheck(this, PaymentProfileService);

      return _possibleConstructorReturn(this, (PaymentProfileService.__proto__ || Object.getPrototypeOf(PaymentProfileService)).call(this, paymentProfile, 'PaymentProfileService'));
    }

    _createClass(PaymentProfileService, [{
      key: 'createByNonceToken',
      value: function createByNonceToken(nonceToken, options) {
        if (!nonceToken) throw new Error('jsSdk.paymentProfile - createByNonceToken() - nonceToken is required');
        options = options || {};
        options.paymentMethodNonce = nonceToken;

        return this._resource.create(options).$promise;
      }
    }, {
      key: 'setDefault',
      value: function setDefault(paymentProfileId, options) {
        if (!paymentProfileId) throw new Error('jsSdk.paymentProfile - setDefault() - paymentProfileId is required');
        options = options || {};
        options.default = true;
        options.id = paymentProfileId;
        return this._resource.updateById(options).$promise;
      }
    }, {
      key: 'listByUserId',
      value: function listByUserId(userId, options) {
        if (!userId) throw new Error('jsSdk.paymentProfile - listByUserId() - userId is required');
        options = options || {};
        options.userId = userId;
        return this._resource.listByUserId(options).$promise;
      }
    }, {
      key: 'listByOrganizationId',
      value: function listByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('jsSdk.paymentProfile - listByOrganizationId() - organizationId is required');
        options = options || {};

        options.organizationId = organizationId;

        return this._resource.listByOrganizationId(options).$promise;
      }
    }, {
      key: 'readByIdAndOrganizationId',
      value: function readByIdAndOrganizationId(id, organizationId, options) {
        if (!id) throw new Error('jsSdk.paymentProfile - readByIdAndOrganizationId() - paymentProfileId is required');
        if (!organizationId) throw new Error('jsSdk.paymentProfile - readByIdAndOrganizationId() - organizationId is required');
        options = options || {};

        options.id = id;
        options.organizationId = organizationId;

        return this._resource.readByIdAndOrganizationId(options).$promise;
      }
    }, {
      key: 'createByOrganizationId',
      value: function createByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('jsSdk.paymentProfile - createByOrganizationId() - organizationId is required');
        if (!options) throw new Error('jsSdk.paymentProfile - createByOrganizationId() - options is required');

        return this._resource.createByOrganizationId({
          organizationId: organizationId
        }, options).$promise;
      }
    }, {
      key: 'setDefaultByIdAndOrganizationId',
      value: function setDefaultByIdAndOrganizationId(id, organizationId, options) {
        if (!id) throw new Error('jsSdk.paymentProfile - setDefaultByIdAndOrganizationId() - id is required');
        if (!organizationId) throw new Error('jsSdk.paymentProfile - setDefaultByIdAndOrganizationId() - organizationId is required');
        options = options || {};

        return this._resource.setDefaultByIdAndOrganizationId({
          id: id,
          organizationId: organizationId
        }, options).$promise;
      }
    }]);

    return PaymentProfileService;
  }(CommonService);

  return new PaymentProfileService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.paymentProfile.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/paymentProfile/:id';
  var PARAM_DEFAULTS = {
    id: '@id',
    userId: '@userId'
  };

  var paymentProfile = resourceFactory('jsSdk.paymentProfile.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByUserId: {
      method: 'GET',
      url: '/user/:userId/payment-profile',
      isArray: true
    },
    listByOrganizationId: {
      method: 'GET',
      url: 'organization/:organizationId/payment-profile',
      isArray: true
    },
    createByOrganizationId: {
      method: 'POST',
      url: 'organization/:organizationId/payment-profile',
      isArray: false
    },
    readByIdAndOrganizationId: {
      method: 'GET',
      url: 'organization/:organizationId/payment-profile/:id',
      isArray: false
    },
    setDefaultByIdAndOrganizationId: {
      method: 'PUT',
      url: 'organization/:organizationId/payment-profile/:id',
      isArray: false
    }
  });

  return paymentProfile;
}]);
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.permission', ['jsSdk.commonService', 'jsSdk.permission.resource', function (CommonService, permission) {
  var PermissionService = function (_CommonService) {
    _inherits(PermissionService, _CommonService);

    function PermissionService() {
      _classCallCheck(this, PermissionService);

      return _possibleConstructorReturn(this, (PermissionService.__proto__ || Object.getPrototypeOf(PermissionService)).call(this, permission, 'PermissionService'));
    }

    return PermissionService;
  }(CommonService);

  return new PermissionService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.permission.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/permission/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Permission = resourceFactory('jsSdk.permission.resource', ENDPOINT, PARAM_DEFAULTS, {
    list: {
      method: 'GET',
      url: 'permission-type',
      isArray: true
    }
  });

  return Permission;
}]);
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.platformFeeStructure', ['jsSdk.commonService', 'jsSdk.platformFeeStructure.resource', function (CommonService, platformFeeStructure) {
  var PlatformFeeStructureService = function (_CommonService) {
    _inherits(PlatformFeeStructureService, _CommonService);

    function PlatformFeeStructureService() {
      _classCallCheck(this, PlatformFeeStructureService);

      return _possibleConstructorReturn(this, (PlatformFeeStructureService.__proto__ || Object.getPrototypeOf(PlatformFeeStructureService)).call(this, platformFeeStructure, 'PlatformFeeStructureService'));
    }

    return PlatformFeeStructureService;
  }(CommonService);

  return new PlatformFeeStructureService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.platformFeeStructure.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/platform-fee-structure/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var PlatformFeeStructure = resourceFactory('jsSdk.platformFeeStructure.resource', ENDPOINT, PARAM_DEFAULTS, {});

  return PlatformFeeStructure;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.promo', ['jsSdk.commonService', 'jsSdk.promo.resource', function (CommonService, promo) {
  var PromoService = function (_CommonService) {
    _inherits(PromoService, _CommonService);

    function PromoService() {
      _classCallCheck(this, PromoService);

      return _possibleConstructorReturn(this, (PromoService.__proto__ || Object.getPrototypeOf(PromoService)).call(this, promo, 'PromoService'));
    }

    _createClass(PromoService, [{
      key: 'checkCode',
      value: function checkCode(code) {
        if (!code) throw new Error('jsSdk.promo - checkCode() - code is required');

        return this._resource.checkCode({
          code: code
        }).$promise;
      }
    }, {
      key: 'redeem',
      value: function redeem(options) {
        if (!options) throw new Error('jsSdk.promo - redeem() - options is required');
        if (!options.code) throw new Error('jsSdk.promo - redeem() - options.code is required');

        return this._resource.redeem(options).$promise;
      }
    }, {
      key: 'listByQuery',
      value: function listByQuery(options) {
        options = options || {};

        options.limit = options.limit || this.DEFAULT_LIMIT;
        options.sort = options.sort || this.DEFAULT_SORT;
        options.query = options.query ? JSON.stringify(options.query) : options.query;

        return this._resource.listByQuery(options).$promise;
      }
    }, {
      key: 'listUsesById',
      value: function listUsesById(id, options) {
        if (!id) throw new Error('jsSdk.promo - listUsesById() - id is required');
        options = options || {};

        options.limit = options.limit || this.DEFAULT_LIMIT;
        options.sort = options.sort || this.DEFAULT_SORT;
        options.query = options.query ? JSON.stringify(options.query) : options.query;

        return this._resource.listUsesById({
          id: id
        }, options).$promise;
      }
    }, {
      key: 'listByCampaignId',
      value: function listByCampaignId(campaignId, options) {
        if (!campaignId) throw new Error('jsSdk.promo - listByCampaignId() - campaignId is required');

        options = options || {};
        options.campaignId = campaignId;

        return this._resource.listByCampaignId(options).$promise;
      }
    }, {
      key: 'listByEventId',
      value: function listByEventId(eventId, options) {
        if (!eventId) throw new Error('jsSdk.promo - listByEventId() - eventId is required');

        return this._resource.listByEventId({
          eventId: eventId
        }, options).$promise;
      }
    }, {
      key: 'addByEventId',
      value: function addByEventId(eventId, options) {
        if (!eventId) throw new Error('jsSdk.promo - addByEventId() - eventId is required');
        if (!options) throw new Error('jsSdk.promo - addByEventId() - options is required');

        return this._resource.addByEventId({
          eventId: eventId
        }, options).$promise;
      }
    }, {
      key: 'removeByIdAndEventId',
      value: function removeByIdAndEventId(promoId, eventId, options) {
        if (!promoId) throw new Error('jsSdk.promo - removeByEventId() - promoId is required');
        if (!eventId) throw new Error('jsSdk.promo - removeByEventId() - eventId is required');

        return this._resource.removeByIdAndEventId({
          eventId: eventId,
          promoId: promoId
        }, options).$promise;
      }
    }, {
      key: 'listByInventoryId',
      value: function listByInventoryId(inventoryId, options) {
        if (!inventoryId) throw new Error('jsSdk.promo - listByInventoryId() - inventoryId is required');

        return this._resource.listByInventoryId({
          inventoryId: inventoryId
        }, options).$promise;
      }
    }, {
      key: 'addByInventoryId',
      value: function addByInventoryId(inventoryId, options) {
        if (!inventoryId) throw new Error('jsSdk.promo - addByInventoryId() - inventoryId is required');
        if (!options) throw new Error('jsSdk.promo - addByInventoryId() - options is required');

        return this._resource.addByInventoryId({
          inventoryId: inventoryId
        }, options).$promise;
      }
    }, {
      key: 'removeByIdAndInventoryId',
      value: function removeByIdAndInventoryId(promoId, inventoryId, options) {
        if (!promoId) throw new Error('jsSdk.promo - removeByInventoryId() - promoId is required');
        if (!inventoryId) throw new Error('jsSdk.promo - removeByInventoryId() - inventoryId is required');

        return this._resource.removeByIdAndInventoryId({
          inventoryId: inventoryId,
          promoId: promoId
        }, options).$promise;
      }
    }]);

    return PromoService;
  }(CommonService);

  return new PromoService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.promo.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/promo/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Promo = resourceFactory('jsSdk.promo.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByQuery: {
      method: 'GET',
      url: '/promo/query',
      isArray: true
    },
    listUsesById: {
      method: 'GET',
      url: ENDPOINT + '/use',
      isArray: true
    },
    checkCode: {
      method: 'GET',
      url: ENDPOINT + '/check/:code',
      params: {
        code: '@code'
      }
    },
    redeem: {
      method: 'POST',
      url: ENDPOINT + '/redeem'
    },
    listByCampaignId: {
      method: 'GET',
      url: 'campaign/:campaignId/promo',
      isArray: true,
      params: {
        campaignId: '@campaignId'
      }
    },

    listByEventId: {
      method: 'GET',
      url: 'event/:eventId/promo',
      isArray: true,
      params: {
        eventId: '@eventId'
      }
    },
    addByEventId: {
      method: 'POST',
      url: 'event/:eventId/promo',
      params: {
        eventId: '@eventId'
      }
    },
    removeByIdAndEventId: {
      method: 'DELETE',
      url: 'event/:eventId/promo/:promoId',
      params: {
        eventId: '@eventId',
        promoId: '@promoId'
      }
    },

    listByInventoryId: {
      method: 'GET',
      url: 'inventory/:inventoryId/promo',
      isArray: true,
      params: {
        inventoryId: '@inventoryId'
      }
    },
    addByInventoryId: {
      method: 'POST',
      url: 'inventory/:inventoryId/promo',
      params: {
        inventoryId: '@inventoryId'
      }
    },
    removeByIdAndInventoryId: {
      method: 'DELETE',
      url: 'inventory/:inventoryId/promo/:promoId',
      params: {
        inventoryId: '@inventoryId',
        promoId: '@promoId'
      }
    }
  });

  return Promo;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.referral', ['jsSdk.commonService', 'jsSdk.referral.resource', function (CommonService, referral) {
  var ReferralService = function (_CommonService) {
    _inherits(ReferralService, _CommonService);

    function ReferralService() {
      _classCallCheck(this, ReferralService);

      return _possibleConstructorReturn(this, (ReferralService.__proto__ || Object.getPrototypeOf(ReferralService)).call(this, referral, 'ReferralService'));
    }

    _createClass(ReferralService, [{
      key: 'listByUserId',
      value: function listByUserId(userId, options) {
        if (!userId) throw new Error('jsSdk.referral - listByUserId() - userId is required');

        options = options || {};
        options.userId = userId;

        return this._resource.listByUserId(options).$promise;
      }
    }]);

    return ReferralService;
  }(CommonService);

  return new ReferralService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.referral.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/referral/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Referral = resourceFactory('jsSdk.referral.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByUserId: {
      method: 'GET',
      url: '/user/:userId/referral',
      isArray: true
    }
  });

  return Referral;
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.review.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/review/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Track = resourceFactory('jsSdk.review.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByUserId: {
      method: 'GET',
      url: '/user/:userId/review',
      isArray: true,
      params: {
        userId: '@userId'
      }
    }
  });

  return Track;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.review', ['jsSdk.commonService', 'jsSdk.review.resource', function (CommonService, review) {
  var ReviewService = function (_CommonService) {
    _inherits(ReviewService, _CommonService);

    function ReviewService() {
      _classCallCheck(this, ReviewService);

      return _possibleConstructorReturn(this, (ReviewService.__proto__ || Object.getPrototypeOf(ReviewService)).call(this, review, 'ReviewService'));
    }

    _createClass(ReviewService, [{
      key: 'read',
      value: function read(reviewId, options) {
        if (!reviewId) throw new Error('jsSdk.review - read() - reviewId is required');
        options = options || {};

        options.id = reviewId;
        return this._resource.readById(options).$promise;
      }
    }, {
      key: 'update',
      value: function update(reviewId, options) {
        if (!reviewId) throw new Error('jsSdk.review - update() - reviewId is required');
        if (!options) throw new Error('jsSdk.review - update() - options is required');

        options.id = reviewId;
        return this._resource.updateById(options).$promise;
      }
    }, {
      key: 'listByUserId',
      value: function listByUserId(userId, options) {
        if (!userId) throw new Error('jsSdk.review - listByUserId() - userId is required');
        options = options || {};

        options.userId = userId;
        return this._resource.listByUserId(options).$promise;
      }
    }]);

    return ReviewService;
  }(CommonService);

  return new ReviewService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.schedule.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/schedule/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Schedule = resourceFactory('jsSdk.schedule.resource', ENDPOINT, PARAM_DEFAULTS, {
    create: {
      method: 'POST',
      url: ENDPOINT
    },
    updateById: {
      method: 'PUT',
      url: ENDPOINT
    },
    deleteById: {
      method: 'DELETE',
      url: ENDPOINT
    },
    listByVenueId: {
      method: 'GET',
      url: '/schedule',
      isArray: true
    }
  });

  return Schedule;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.schedule', ['jsSdk.commonService', 'jsSdk.schedule.resource', function (CommonService, schedule) {
  var ScheduleService = function (_CommonService) {
    _inherits(ScheduleService, _CommonService);

    function ScheduleService() {
      _classCallCheck(this, ScheduleService);

      return _possibleConstructorReturn(this, (ScheduleService.__proto__ || Object.getPrototypeOf(ScheduleService)).call(this, schedule, 'ScheduleService'));
    }

    _createClass(ScheduleService, [{
      key: 'listByVenueId',
      value: function listByVenueId(venueId, options) {
        if (!venueId) throw new Error('jsSdk.schedule - listByVenueId() - venueId is required');
        options = options || {};

        return this._resource.listByVenueId({
          venue: venueId
        }, options).$promise;
      }
    }]);

    return ScheduleService;
  }(CommonService);

  return new ScheduleService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.scheduledReportConfig.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/scheduled-report-config/:id';

  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var ScheduledReportConfig = resourceFactory('jsSdk.scheduledReportConfig.resource', ENDPOINT, PARAM_DEFAULTS, {
    createByVenueId: {
      method: 'POST',
      url: '/scheduled-report-config'
    },
    performAction: {
      method: 'POST',
      url: '/scheduled-report-config/:id/action'
    },
    listByVenueId: {
      method: 'GET',
      url: '/venue/:venueId/scheduled-report-config',
      isArray: true
    },
    list: {
      method: 'GET',
      url: '/scheduled-report-config',
      isArray: true
    }
  });

  return ScheduledReportConfig;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.scheduledReportConfig', ['jsSdk.commonService', 'jsSdk.scheduledReportConfig.resource', function (CommonService, scheduledReportConfig) {

  var ACTION_TYPES = {
    ADD_RECIPIENT_EMAIL: 'ADD_RECIPIENT_EMAIL',
    REMOVE_RECIPIENT_EMAIL: 'REMOVE_RECIPIENT_EMAIL'
  };

  var ScheduledReportConfigService = function (_CommonService) {
    _inherits(ScheduledReportConfigService, _CommonService);

    function ScheduledReportConfigService() {
      _classCallCheck(this, ScheduledReportConfigService);

      return _possibleConstructorReturn(this, (ScheduledReportConfigService.__proto__ || Object.getPrototypeOf(ScheduledReportConfigService)).call(this, scheduledReportConfig, 'ScheduledReportConfigService'));
    }

    _createClass(ScheduledReportConfigService, [{
      key: 'listByVenueId',
      value: function listByVenueId(venueId, options) {
        if (!venueId) throw new Error('jsSdk.scheduledReportConfig - listByVenueId() - venueId is required');
        options = options || {};
        options.venueId = venueId;
        return this._resource.listByVenueId(options).$promise;
      }
    }, {
      key: 'createByVenueId',
      value: function createByVenueId(venueId, options) {
        if (!venueId) throw new Error('jsSdk.scheduledReportConfig - createByVenueId() - venueId is required');
        if (!options) throw new Error('jsSdk.scheduledReportConfig - createByVenueId() - options is required');
        options.venueId = venueId;
        return this._resource.createByVenueId(options).$promise;
      }
    }, {
      key: 'addEmailRecipient',
      value: function addEmailRecipient(reportId, options) {
        if (!reportId) throw new Error('jsSdk.scheduledReportConfig - addEmailRecipient() - reportId is required');
        if (!options) throw new Error('jsSdk.scheduledReportConfig - addEmailRecipient() - options is required');

        options.type = ACTION_TYPES.ADD_RECIPIENT_EMAIL;
        options.id = reportId;
        return this._resource.performAction(options).$promise;
      }
    }, {
      key: 'removeEmailRecipient',
      value: function removeEmailRecipient(reportId, options) {
        if (!reportId) throw new Error('jsSdk.scheduledReportConfig - removeEmailRecipient() - reportId is required');
        if (!options) throw new Error('jsSdk.scheduledReportConfig - removeEmailRecipient() - options is required');

        options.type = ACTION_TYPES.REMOVE_RECIPIENT_EMAIL;
        options.id = reportId;
        return this._resource.performAction(options).$promise;
      }
    }, {
      key: 'list',
      value: function list(options) {
        options = options || {};
        return this._resource.list(options).$promise;
      }
    }]);

    return ScheduledReportConfigService;
  }(CommonService);

  return new ScheduledReportConfigService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.search.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/search-consumer';
  var PARAM_DEFAULTS = {};

  var Search = resourceFactory('jsSdk.search.resource', ENDPOINT, PARAM_DEFAULTS, {
    searchConsumer: {
      method: 'GET',
      url: ENDPOINT
    },
    listConsumerTypes: {
      method: 'GET',
      url: '/search-consumer-type',
      isArray: true
    }
  });

  return Search;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.search', ['jsSdk.commonService', 'jsSdk.search.resource', function (CommonService, search) {
  var SearchService = function (_CommonService) {
    _inherits(SearchService, _CommonService);

    function SearchService() {
      _classCallCheck(this, SearchService);

      return _possibleConstructorReturn(this, (SearchService.__proto__ || Object.getPrototypeOf(SearchService)).call(this, search, 'SearchService'));
    }

    _createClass(SearchService, [{
      key: 'searchConsumer',
      value: function searchConsumer(options) {
        if (!options) throw new Error('jsSdk.search - searchConsumer() - options is required');
        if (!options.type) throw new Error('jsSdk.search - searchConsumer() - options.type is required');
        return this._resource.searchConsumer(options).$promise;
      }
    }, {
      key: 'listConsumerTypes',
      value: function listConsumerTypes(options) {
        options = options || {};
        return this._resource.listConsumerTypes(options).$promise;
      }
    }]);

    return SearchService;
  }(CommonService);

  return new SearchService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.server.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/server/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Server = resourceFactory('jsSdk.server.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByOrganizationId: {
      method: 'GET',
      url: '/organization/:organizationId/server',
      isArray: true
    }
  });

  return Server;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.server', ['jsSdk.commonService', 'jsSdk.server.resource', function (CommonService, server) {
  var ServerService = function (_CommonService) {
    _inherits(ServerService, _CommonService);

    function ServerService() {
      _classCallCheck(this, ServerService);

      return _possibleConstructorReturn(this, (ServerService.__proto__ || Object.getPrototypeOf(ServerService)).call(this, server, 'ServerService'));
    }

    _createClass(ServerService, [{
      key: 'listByOrganizationId',
      value: function listByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('organizationId is required');

        options = options || {};

        options.organizationId = organizationId;

        return this._resource.listByOrganizationId(options).$promise;
      }
    }]);

    return ServerService;
  }(CommonService);

  return new ServerService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.settings.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/config';

  var PARAM_DEFAULTS = {};

  var Settings = resourceFactory('jsSdk.settings.resource', ENDPOINT, PARAM_DEFAULTS, {
    readConfig: {
      method: 'GET',
      url: ENDPOINT
    },
    paymentConfig: {
      method: 'POST',
      url: '/client/payment-config'
    }
  });

  return Settings;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.settings', ['jsSdk.commonService', 'jsSdk.settings.resource', function (CommonService, settings) {
  var SettingsService = function (_CommonService) {
    _inherits(SettingsService, _CommonService);

    function SettingsService() {
      _classCallCheck(this, SettingsService);

      return _possibleConstructorReturn(this, (SettingsService.__proto__ || Object.getPrototypeOf(SettingsService)).call(this, settings, 'SettingsService'));
    }

    _createClass(SettingsService, [{
      key: 'readConfig',
      value: function readConfig(options) {
        options = options || {};
        return this._resource.readConfig(options).$promise;
      }
    }, {
      key: 'paymentConfig',
      value: function paymentConfig(options) {
        options = options || {};
        return this._resource.paymentConfig(options).$promise;
      }
    }]);

    return SettingsService;
  }(CommonService);

  return new SettingsService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.tag.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/tag/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Tag = resourceFactory('jsSdk.tag.resource', ENDPOINT, PARAM_DEFAULTS, {});

  return Tag;
}]);
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.tag', ['jsSdk.commonService', 'jsSdk.tag.resource', function (CommonService, tag) {
  var TagService = function (_CommonService) {
    _inherits(TagService, _CommonService);

    function TagService() {
      _classCallCheck(this, TagService);

      return _possibleConstructorReturn(this, (TagService.__proto__ || Object.getPrototypeOf(TagService)).call(this, tag, 'TagService'));
    }

    return TagService;
  }(CommonService);

  return new TagService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.tallyAggregate.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/tally-aggregate/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var TallyAggregate = resourceFactory('jsSdk.tallyAggregate.resource', ENDPOINT, PARAM_DEFAULTS);

  return TallyAggregate;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.tallyAggregate', ['$window', 'jsSdk.commonService', 'jsSdk.tallyAggregate.resource', function ($window, CommonService, tallyAggregate) {
  var TallyAggregate = function (_CommonService) {
    _inherits(TallyAggregate, _CommonService);

    function TallyAggregate() {
      _classCallCheck(this, TallyAggregate);

      return _possibleConstructorReturn(this, (TallyAggregate.__proto__ || Object.getPrototypeOf(TallyAggregate)).call(this, tallyAggregate, 'TallyAggregateService'));
    }

    _createClass(TallyAggregate, [{
      key: 'list',
      value: function list(options) {
        options = options || {};

        return this._resource.list(options).$promise;
      }
    }, {
      key: 'readById',
      value: function readById() {
        throw new Error('jsSdk.tallyAggregate - readById() - disabled');
      }
    }, {
      key: 'create',
      value: function create() {
        throw new Error('jsSdk.tallyAggregate - create() - disabled');
      }
    }, {
      key: 'updateById',
      value: function updateById() {
        throw new Error('jsSdk.tallyAggregate - updateById() - disabled');
      }
    }, {
      key: 'patchById',
      value: function patchById() {
        throw new Error('jsSdk.tallyAggregate - patchById() - disabled');
      }
    }, {
      key: 'deleteById',
      value: function deleteById() {
        throw new Error('jsSdk.tallyAggregate - deleteById() - disabled');
      }
    }]);

    return TallyAggregate;
  }(CommonService);

  return new TallyAggregate();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.ticket.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/ticket/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Ticket = resourceFactory('jsSdk.ticket.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByBookingId: {
      method: 'GET',
      url: '/booking/:bookingId/ticket',
      isArray: true,
      params: {
        bookingId: '@bookingId'
      }
    },
    listByAdmissionGroupId: {
      method: 'GET',
      url: '/admission-group/:admissionGroupId/ticket',
      isArray: true
    },
    checkInById: {
      method: 'POST',
      url: ENDPOINT + '/checkIn',
      isArray: false
    }
  });

  return Ticket;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.ticket', ['$window', 'jsSdk.commonService', 'jsSdk.ticket.resource', function ($window, CommonService, ticketResource) {
  var TicketService = function (_CommonService) {
    _inherits(TicketService, _CommonService);

    function TicketService() {
      _classCallCheck(this, TicketService);

      return _possibleConstructorReturn(this, (TicketService.__proto__ || Object.getPrototypeOf(TicketService)).call(this, ticketResource, 'TicketService'));
    }

    _createClass(TicketService, [{
      key: 'listByBookingId',
      value: function listByBookingId(bookingId, options) {
        if (!bookingId) throw new Error('jsSdk.ticket - listByBookingId() - bookingId is required');
        options = options || {};

        options.bookingId = bookingId;

        return this._resource.listByBookingId(options).$promise;
      }
    }, {
      key: 'listByAdmissionGroupId',
      value: function listByAdmissionGroupId(admissionGroupId, options) {
        if (!admissionGroupId) throw new Error('jsSdk.ticket - listByAdmissionGroupId() - admissionGroupId is required');
        options = options || {};

        options.admissionGroupId = admissionGroupId;

        return this._resource.listByAdmissionGroupId(options).$promise;
      }
    }, {
      key: 'checkInById',
      value: function checkInById(id, options) {
        if (!id) throw new Error('jsSdk.ticket - checkInById() - id is required');
        options = options || {};

        return this._resource.checkInById({
          id: id
        }, options).$promise;
      }
    }]);

    return TicketService;
  }(CommonService);

  return new TicketService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.ticketStat.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/';
  var PARAM_DEFAULTS = {};

  var TicketStat = resourceFactory('jsSdk.ticketStat.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByEventId: {
      method: 'GET',
      url: '/event/:eventId/ticket-stat',
      isArray: true,
      params: {
        eventId: '@eventId'
      }
    }
  });

  return TicketStat;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.ticketStat', ['$window', 'jsSdk.commonService', 'jsSdk.ticketStat.resource', function ($window, CommonService, ticketStat) {
  var TicketStatService = function (_CommonService) {
    _inherits(TicketStatService, _CommonService);

    function TicketStatService() {
      _classCallCheck(this, TicketStatService);

      return _possibleConstructorReturn(this, (TicketStatService.__proto__ || Object.getPrototypeOf(TicketStatService)).call(this, ticketStat, 'TicketStatService'));
    }

    _createClass(TicketStatService, [{
      key: 'listByEventId',
      value: function listByEventId(eventId, options) {
        if (!eventId) throw new Error('jsSdk.ticketStat - listByEventId() - eventId is required');
        options = options || {};

        options.eventId = eventId;

        return this._resource.listByEventId(options).$promise;
      }
    }, {
      key: 'readById',
      value: function readById() {
        throw new Error('jsSdk.ticketStat - readById() - disabled');
      }
    }, {
      key: 'create',
      value: function create() {
        throw new Error('jsSdk.ticketStat - create() - disabled');
      }
    }, {
      key: 'list',
      value: function list() {
        throw new Error('jsSdk.ticketStat - list() - disabled');
      }
    }, {
      key: 'updateById',
      value: function updateById() {
        throw new Error('jsSdk.ticketStat - updateById() - disabled');
      }
    }, {
      key: 'patchById',
      value: function patchById() {
        throw new Error('jsSdk.ticketStat - patchById() - disabled');
      }
    }, {
      key: 'deleteById',
      value: function deleteById() {
        throw new Error('jsSdk.ticketStat - deleteById() - disabled');
      }
    }]);

    return TicketStatService;
  }(CommonService);

  return new TicketStatService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.track.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/track/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Track = resourceFactory('jsSdk.track.resource', ENDPOINT, PARAM_DEFAULTS, {});

  return Track;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.track', ['$window', 'jsSdk.commonService', 'jsSdk.track.resource', 'jsSdk.config', function ($window, CommonService, trackResource, sdkConfig) {
  var TrackService = function (_CommonService) {
    _inherits(TrackService, _CommonService);

    function TrackService() {
      _classCallCheck(this, TrackService);

      return _possibleConstructorReturn(this, (TrackService.__proto__ || Object.getPrototypeOf(TrackService)).call(this, trackResource, 'TrackService'));
    }

    _createClass(TrackService, [{
      key: 'create',
      value: function create(name, options) {
        if (!name) throw new Error('jsSdk.track - create() - name is required');
        if (!options) throw new Error('jsSdk.track - create() - options is required');

        var client = {
          os: sdkConfig.subClient ? sdkConfig.client + '-' + sdkConfig.subClient : sdkConfig.client,
          version: sdkConfig.version,
          device: $window.navigator ? $window.navigator.userAgent : null
        };

        if (sdkConfig.affiliateId) options.affiliate = sdkConfig.affiliateId;
        if (sdkConfig.attributionId) options.attributionId = sdkConfig.attributionId;
        if (sdkConfig.attributionType) options.attributionType = sdkConfig.attributionType;

        var trackingData = {};

        trackingData.event = name;

        trackingData.client = client;
        trackingData.data = options;

        return this._resource.create({}, trackingData).$promise;
      }
    }]);

    return TrackService;
  }(CommonService);

  return new TrackService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.user.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/user/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var User = resourceFactory('jsSdk.user.resource', ENDPOINT, PARAM_DEFAULTS, {
    me: {
      method: 'GET',
      url: '/me',
      isArray: false
    },
    updateMe: {
      method: 'PUT',
      url: '/me',
      isArray: false
    },
    updatePreferredCity: {
      method: 'PUT',
      url: '/user/city',
      isArray: false
    }
  });

  return User;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.user', ['$timeout', '$q', 'jsSdk.commonService', 'jsSdk.user.resource', 'jsSdk.keychain', 'jsSdk.localstorage', function ($timeout, $q, CommonService, userResource, keychain, localstorage) {

  var USER_KEY = 'tablelist.com_user';

  var EVENTS = {
    USER_UPDATED: 'USER_UPDATED'
  };

  var UserService = function (_CommonService) {
    _inherits(UserService, _CommonService);

    function UserService() {
      _classCallCheck(this, UserService);

      return _possibleConstructorReturn(this, (UserService.__proto__ || Object.getPrototypeOf(UserService)).call(this, userResource, 'UserService'));
    }

    _createClass(UserService, [{
      key: 'getCurrentUser',
      value: function getCurrentUser() {
        var authToken = keychain.getConsumerAuthToken();
        return authToken ? localstorage.get(USER_KEY) : null;
      }
    }, {
      key: 'setCurrentUser',
      value: function setCurrentUser(user) {
        if (!user) throw new Error('jsSdk.user - setCurrentUser() - user is required');

        localstorage.set(USER_KEY, user);

        this.emit(this.EVENTS.USER_UPDATED, user);

        return user;
      }
    }, {
      key: 'updateMe',
      value: function updateMe(options) {
        var _this2 = this;

        if (!options) throw new Error('jsSdk.user - updateMe() - options is required');

        return this._resource.updateMe(options).$promise.then(function (updatedUser) {
          localstorage.set(USER_KEY, updatedUser);
          _this2.emit(_this2.EVENTS.USER_UPDATED, updatedUser);
          return updatedUser;
        });
      }
    }, {
      key: 'updatePreferredCity',
      value: function updatePreferredCity(cityId, options) {
        var _this3 = this;

        if (!cityId) throw new Error('jsSdk.user - updatePreferredCity() - cityId is required');

        options = options || {};
        options.city = cityId;

        return this._resource.updatePreferredCity(options).$promise.then(function (updatedUser) {
          localstorage.set(USER_KEY, updatedUser);
          _this3.emit(_this3.EVENTS.USER_UPDATED, updatedUser);
          return updatedUser;
        });
      }
    }, {
      key: 'removeCurrentUser',
      value: function removeCurrentUser() {
        localstorage.remove(USER_KEY);

        return true;
      }
    }, {
      key: 'me',
      value: function me(options) {
        var _this4 = this;

        var deferred = $q.defer();

        this._resource.me(options).$promise.then(function (user) {
          _this4.setCurrentUser(user);

          return deferred.resolve(user);
        }).catch(deferred.reject);

        return deferred.promise;
      }
    }, {
      key: 'EVENTS',
      get: function get() {
        return EVENTS;
      }
    }]);

    return UserService;
  }(CommonService);

  return new UserService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.userDiscount.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/user-discount/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var UserDiscount = resourceFactory('jsSdk.userDiscount.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByUserId: {
      method: 'GET',
      url: '/user/:userId/user-discount',
      isArray: true,
      params: {
        userId: '@userId'
      }
    }
  });

  return UserDiscount;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.userDiscount', ['jsSdk.commonService', 'jsSdk.userDiscount.resource', function (CommonService, userDiscount) {
  var UserDiscountService = function (_CommonService) {
    _inherits(UserDiscountService, _CommonService);

    function UserDiscountService() {
      _classCallCheck(this, UserDiscountService);

      return _possibleConstructorReturn(this, (UserDiscountService.__proto__ || Object.getPrototypeOf(UserDiscountService)).call(this, userDiscount, 'UserDiscountService'));
    }

    _createClass(UserDiscountService, [{
      key: 'listByUserId',
      value: function listByUserId(userId, options) {
        if (!userId) throw new Error('jsSdk.userDiscount - listByUserId() - userId is required');

        options = options || {};
        options.userId = userId;

        return this._resource.listByUserId(options).$promise;
      }
    }]);

    return UserDiscountService;
  }(CommonService);

  return new UserDiscountService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.venue.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/venue/:id';
  var PARAM_DEFAULTS = {
    id: '@id'
  };

  var Venue = resourceFactory('jsSdk.venue.resource', ENDPOINT, PARAM_DEFAULTS, {
    listByOrganizationId: {
      method: 'GET',
      url: 'organization/:organizationId/venue',
      isArray: true
    },
    listByCityId: {
      method: 'GET',
      url: '/city/:cityId/venue',
      isArray: true,
      params: {
        cityId: '@cityId'
      }
    },
    createByOrganizationId: {
      method: 'POST',
      url: 'organization/:organizationId/venue',
      isArray: false
    }
  });

  return Venue;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.venue', ['jsSdk.commonService', 'jsSdk.venue.resource', function (CommonService, venue) {
  var VenueService = function (_CommonService) {
    _inherits(VenueService, _CommonService);

    function VenueService() {
      _classCallCheck(this, VenueService);

      return _possibleConstructorReturn(this, (VenueService.__proto__ || Object.getPrototypeOf(VenueService)).call(this, venue, 'VenueService'));
    }

    _createClass(VenueService, [{
      key: 'createByOrganizationId',
      value: function createByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('jsSdk.organization - createByOrganizationId() - organizationId is required');
        if (!options) throw new Error('jsSdk.organization - createByOrganizationId() - options is required');

        return this._resource.createByOrganizationId({
          organizationId: organizationId
        }, options).$promise;
      }
    }, {
      key: 'listByOrganizationId',
      value: function listByOrganizationId(organizationId, options) {
        if (!organizationId) throw new Error('jsSdk.venue - listByOrganizationId() - organizationId is required');

        options = options || {};
        options.organizationId = organizationId;
        options.limit = options.limit || this.DEFAULT_LIMIT;
        options.sort = options.sort || this.DEFAULT_SORT;

        return this._resource.listByOrganizationId(options).$promise;
      }
    }, {
      key: 'listByCityId',
      value: function listByCityId(cityId, options) {
        if (!cityId) throw new Error('jsSdk.venue - listByCityId() - cityId is required');

        options = options || {};
        options.cityId = cityId;
        options.limit = options.limit || this.DEFAULT_LIMIT;
        options.sort = options.sort || this.DEFAULT_SORT;

        return this._resource.listByCityId(options).$promise;
      }
    }]);

    return VenueService;
  }(CommonService);

  return new VenueService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.venueInfo.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/venue/:venueId/info';

  var PARAM_DEFAULTS = {
    venueId: '@venueId',
    key: '@key'
  };

  var Item = resourceFactory('jsSdk.venueInfo.resource', ENDPOINT, PARAM_DEFAULTS, {
    read: {
      method: 'GET',
      url: ENDPOINT + '/:key'
    },
    create: {
      method: 'POST',
      url: ENDPOINT,
      params: {
        venueId: '@venueId'
      }
    },
    listByVenueId: {
      method: 'GET',
      url: ENDPOINT,
      isArray: true
    },
    update: {
      method: 'PUT',
      url: ENDPOINT + '/:key'
    }
  });

  return Item;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.venueInfo', ['jsSdk.commonService', 'jsSdk.venueInfo.resource', function (CommonService, venueInfo) {
  var VenueInfoService = function (_CommonService) {
    _inherits(VenueInfoService, _CommonService);

    function VenueInfoService() {
      _classCallCheck(this, VenueInfoService);

      return _possibleConstructorReturn(this, (VenueInfoService.__proto__ || Object.getPrototypeOf(VenueInfoService)).call(this, venueInfo, 'VenueInfoService'));
    }

    _createClass(VenueInfoService, [{
      key: 'read',
      value: function read(venueId, options) {
        if (!venueId) throw new Error('jsSdk.venueInfo - read() - venueId is required');
        if (!options) throw new Error('jsSdk.venueInfo - read() - options is required');
        if (!options.key) throw new Error('jsSdk.venueInfo - read() - options.key is required');

        options.venueId = venueId;

        return this._resource.read(options).$promise;
      }
    }, {
      key: 'listByVenueId',
      value: function listByVenueId(venueId, options) {
        if (!venueId) throw new Error('jsSdk.venueInfo - listByVenueId() - venueId is required');
        options = options || {};
        options.venueId = venueId;

        return this._resource.listByVenueId(options).$promise;
      }
    }, {
      key: 'create',
      value: function create(venueId, options) {
        if (!venueId) throw new Error('jsSdk.venueInfo - create() - venueId is required');
        if (!options) throw new Error('jsSdk.venueInfo - create() - options is required');
        if (!options.key) throw new Error('jsSdk.venueInfo - create() - options.key is required');

        options.venueId = venueId;

        return this._resource.create(options).$promise;
      }
    }, {
      key: 'update',
      value: function update(venueId, options) {
        if (!venueId) throw new Error('jsSdk.venueInfo - update() - venueId is required');
        if (!options) throw new Error('jsSdk.venueInfo - update() - options is required');
        if (!options.key) throw new Error('jsSdk.venueInfo - update() - options.key is required');

        options.venueId = venueId;

        return this._resource.update(options).$promise;
      }
    }]);

    return VenueInfoService;
  }(CommonService);

  return new VenueInfoService();
}]);
'use strict';

angular.module('jsSdk').service('jsSdk.venueItem.resource', ['jsSdk.resourceFactory', function (resourceFactory) {

  var ENDPOINT = '/venue/:venueId/item';
  var PARAM_DEFAULTS = {
    venueId: '@venueId',
    id: '@id'
  };

  var VenueItem = resourceFactory('jsSdk.venueItem.resource', ENDPOINT, PARAM_DEFAULTS, {
    create: {
      method: 'POST',
      url: ENDPOINT
    },
    updateById: {
      method: 'PUT',
      url: ENDPOINT + '/:id'
    },
    deleteById: {
      method: 'DELETE',
      url: ENDPOINT + '/:id'
    },
    listByVenueId: {
      method: 'GET',
      url: ENDPOINT + '/:id',
      isArray: true
    }
  });

  return VenueItem;
}]);
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('jsSdk').service('jsSdk.venueItem', ['jsSdk.commonService', 'jsSdk.venueItem.resource', function (CommonService, venueItem) {
  var VenueItemService = function (_CommonService) {
    _inherits(VenueItemService, _CommonService);

    function VenueItemService() {
      _classCallCheck(this, VenueItemService);

      return _possibleConstructorReturn(this, (VenueItemService.__proto__ || Object.getPrototypeOf(VenueItemService)).call(this, venueItem, 'VenueItemService'));
    }

    _createClass(VenueItemService, [{
      key: 'create',
      value: function create(venueId, options) {
        if (!venueId) throw new Error('jsSdk.venueItem - create() - venueId is required');
        if (!options) throw new Error('jsSdk.venueItem - create() - options is required');
        return this._resource.create({
          venueId: venueId
        }, options).$promise;
      }
    }, {
      key: 'updateById',
      value: function updateById(venueId, id, options) {
        if (!venueId) throw new Error('jsSdk.venueItem - updateById() - venueId is required');
        if (!id) throw new Error('jsSdk.venueItem - updateById() - id is required');
        if (!options) throw new Error('jsSdk.venueItem - updateById() - options is required');
        if (!options.itemId) throw new Error('jsSdk.venueItem - updateById() - options.itemId is required');
        if (!options.price) throw new Error('jsSdk.venueItem - updateById() - options.price is required');

        return this._resource.updateById({
          id: id,
          venueId: venueId,
          itemId: options.itemId
        }, options).$promise;
      }
    }, {
      key: 'deleteById',
      value: function deleteById(venueId, id, options) {
        if (!venueId) throw new Error('jsSdk.venueItem - deleteById() - venueId is required');
        if (!id) throw new Error('jsSdk.venueItem - deleteById() - id is required');

        return this._resource.deleteById({
          venueId: venueId,
          id: id
        }, options).$promise;
      }
    }, {
      key: 'listByVenueId',
      value: function listByVenueId(venueId, options) {
        if (!venueId) throw new Error('jsSdk.venueItem - listByVenueId() - venueId is required');

        options = options || {};
        options.venueId = venueId;

        return this._resource.listByVenueId(options).$promise;
      }
    }]);

    return VenueItemService;
  }(CommonService);

  return new VenueItemService();
}]);


//////////////////
// WEBPACK FOOTER
// ./~/@tablelist/tablelist-js-sdk/release/tablelist-js-sdk.admin.js
// module id = 270
// module chunks = 0